import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { IonAlert, IonLabel, IonButton, IonItem, IonInput, IonList, IonGrid, IonRow, IonChip, IonIcon, IonToast, IonSegmentButton, IonCardHeader, IonCardContent, IonCard, IonCardSubtitle, IonCardTitle, IonProgressBar, IonModal, IonText, IonSearchbar, IonListHeader, IonActionSheet, IonTextarea, IonCheckbox, IonMenu, IonHeader, IonToolbar, IonTitle, IonReorder, IonButtons, IonSegment, IonFab, IonFabButton, IonContent, IonReorderGroup } from '@ionic/react';
import React, { useState, useEffect, forwardRef, createElement, Component, useCallback, useRef } from 'react';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import updateLocale from 'dayjs/plugin/updateLocale';
import isToday from 'dayjs/plugin/isToday';
import 'dayjs/locale/es';
import { es, enUS, ptBR } from 'date-fns/locale';
import { Calendar, DatePickerCalendar, DateRangePickerCalendar } from 'react-nice-dates';
import { getDay } from 'date-fns';
import 'react-nice-dates/build/style.css';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$u = "@import \"@ionic/react/css/core.css\";@import \"@ionic/react/css/display.css\";@import \"@ionic/react/css/flex-utils.css\";@import \"@ionic/react/css/float-elements.css\";@import \"@ionic/react/css/normalize.css\";@import \"@ionic/react/css/padding.css\";@import \"@ionic/react/css/structure.css\";@import \"@ionic/react/css/text-alignment.css\";@import \"@ionic/react/css/text-transformation.css\";@import \"@ionic/react/css/typography.css\";:root{--ion-color-primary:#111;--ion-color-primary-rgb:17,17,17;--ion-color-primary-contrast:#fff;--ion-color-primary-contrast-rgb:255,255,255;--ion-color-primary-shade:#0f0f0f;--ion-color-primary-tint:#292929;--ion-color-secondary:red;--ion-color-secondary-rgb:255,0,0;--ion-color-secondary-contrast:#fff;--ion-color-secondary-contrast-rgb:255,255,255;--ion-color-secondary-shade:#e00000;--ion-color-secondary-tint:#ff1a1a;--ion-color-tertiary:#fff;--ion-color-tertiary-rgb:255,255,255;--ion-color-tertiary-contrast:#000;--ion-color-tertiary-contrast-rgb:255,255,255;--ion-color-tertiary-shade:#e0e0e0;--ion-color-tertiary-tint:#fff;--ion-color-quaternary:#e8e8e8;--ion-color-quaternary-rgb:255,255,255;--ion-color-quaternary-contrast:#000;--ion-color-quaternary-contrast-rgb:255,255,255;--ion-color-quaternary-shade:#e0e0e0;--ion-color-quaternary-tint:#e8e8e8;--ion-color-quinary:#d7cea3;--ion-color-quinary-rgb:255,255,255;--ion-color-quinary-contrast:#000;--ion-color-quinary-contrast-rgb:255,255,255;--ion-color-quinary-shade:#e0e0e0;--ion-color-quinary-tint:#d7cea3;--ion-color-senary:#fffde4;--ion-color-senary-rgb:255,255,255;--ion-color-senary-contrast:#000;--ion-color-senary-contrast-rgb:255,255,255;--ion-color-senary-shade:#e0e0e0;--ion-color-senary-tint:#fffde4;--ion-color-septenary:#f4d9b3;--ion-color-septenary-rgb:255,255,255;--ion-color-septenary-contrast:#000;--ion-color-septenary-contrast-rgb:255,255,255;--ion-color-septenary-shade:#e0e0e0;--ion-color-septenary-tint:#f4d9b3;--ion-color-octonary:#d9e9e9;--ion-color-octonary-rgb:255,255,255;--ion-color-octonary-contrast:#000;--ion-color-octonary-contrast-rgb:255,255,255;--ion-color-octonary-shade:#e0e0e0;--ion-color-octonary-tint:#d9e9e9;--ion-color-success:#4bd27f;--ion-color-success-rgb:255,255,255;--ion-color-success-contrast:#000;--ion-color-success-contrast-rgb:255,255,255;--ion-color-success-shade:#4bd27f;--ion-color-success-tint:#4bd27f;--ion-color-warning:#fcaa4a;--ion-color-warning-rgb:255,255,255;--ion-color-warning-contrast:#000;--ion-color-warning-contrast-rgb:255,255,255;--ion-color-warning-shade:#e0ac08;--ion-color-warning-tint:#fcaa4a;--ion-color-danger:#eb445a;--ion-color-danger-rgb:255,255,255;--ion-color-danger-contrast:#fff;--ion-color-danger-contrast-rgb:255,255,255;--ion-color-danger-shade:#cf3c4f;--ion-color-danger-tint:#ed576b;--ion-color-dark:#696969;--ion-color-dark-rgb:255,255,255;--ion-color-dark-contrast:#fff;--ion-color-dark-contrast-rgb:255,255,255;--ion-color-dark-shade:#696969;--ion-color-dark-tint:#696969;--ion-color-medium:silver;--ion-color-medium-rgb:255,255,255;--ion-color-medium-contrast:#000;--ion-color-medium-contrast-rgb:255,255,255;--ion-color-medium-shade:silver;--ion-color-medium-tint:silver;--ion-color-light:#e5e5e5;--ion-color-light-rgb:245,245,245;--ion-color-light-contrast:#000;--ion-color-light-contrast-rgb:255,255,255;--ion-color-light-shade:#d8d8d8;--ion-color-light-tint:#f6f6f6;--ion-color-lighter:#f5f5f5;--ion-color-lighter-rgb:245,245,245;--ion-color-lighter-contrast:#000;--ion-color-lighter-contrast-rgb:255,255,255;--ion-color-lighter-shade:#d8d8d8;--ion-color-lighter-tint:#f6f6f6;--ion-color-disabled:#f5f5f5;--ion-color-disabled-rgb:255,255,255;--ion-color-disabled-contrast:silver;--ion-color-disabled-contrast-rgb:255,255,255;--ion-color-disabled-shade:#0f0f0f;--ion-color-disabled-tint:#292929;--ion-footer-background:var(--ion-color-primary-contrast)}.ion-color-tertiary{--ion-color-base:var(--ion-color-tertiary);--ion-color-base-rgb:var(--ion-color-tertiary-rgb);--ion-color-contrast:var(--ion-color-tertiary-contrast);--ion-color-contrast-rgb:var(--ion-color-tertiary-contrast-rgb);--ion-color-shade:var(--ion-color-tertiary-shade);--ion-color-tint:var(--ion-color-tertiary-tint)}.ion-color-quaternary{--ion-color-base:var(--ion-color-quaternary);--ion-color-base-rgb:var(--ion-color-quaternary-rgb);--ion-color-contrast:var(--ion-color-quaternary-contrast);--ion-color-contrast-rgb:var(--ion-color-quaternary-contrast-rgb);--ion-color-shade:var(--ion-color-quaternary-shade);--ion-color-tint:var(--ion-color-quaternary-tint)}.ion-color-quinary{--ion-color-base:var(--ion-color-quinary);--ion-color-base-rgb:var(--ion-color-quinary-rgb);--ion-color-contrast:var(--ion-color-quinary-contrast);--ion-color-contrast-rgb:var(--ion-color-quinary-contrast-rgb);--ion-color-shade:var(--ion-color-quinary-shade);--ion-color-tint:var(--ion-color-quinary-tint)}.ion-color-senary{--ion-color-base:var(--ion-color-senary);--ion-color-base-rgb:var(--ion-color-senary-rgb);--ion-color-contrast:var(--ion-color-senary-contrast);--ion-color-contrast-rgb:var(--ion-color-senary-contrast-rgb);--ion-color-shade:var(--ion-color-senary-shade);--ion-color-tint:var(--ion-color-senary-tint)}.ion-color-septenary{--ion-color-base:var(--ion-color-septenary);--ion-color-base-rgb:var(--ion-color-septenary-rgb);--ion-color-contrast:var(--ion-color-septenary-contrast);--ion-color-contrast-rgb:var(--ion-color-septenary-contrast-rgb);--ion-color-shade:var(--ion-color-septenary-shade);--ion-color-tint:var(--ion-color-septenary-tint)}.ion-color-octonary{--ion-color-base:var(--ion-color-octonary);--ion-color-base-rgb:var(--ion-color-octonary-rgb);--ion-color-contrast:var(--ion-color-octonary-contrast);--ion-color-contrast-rgb:var(--ion-color-octonary-contrast-rgb);--ion-color-shade:var(--ion-color-octonary-shade);--ion-color-tint:var(--ion-color-octonary-tint)}.ion-color-dark{--ion-color-base:var(--ion-color-dark);--ion-color-base-rgb:var(--ion-color-dark-rgb);--ion-color-contrast:var(--ion-color-dark-contrast);--ion-color-contrast-rgb:var(--ion-color-dark-contrast-rgb);--ion-color-shade:var(--ion-color-dark-shade);--ion-color-tint:var(--ion-color-dark-tint)}.ion-color-medium{--ion-color-base:var(--ion-color-medium);--ion-color-base-rgb:var(--ion-color-medium-rgb);--ion-color-contrast:var(--ion-color-medium-contrast);--ion-color-contrast-rgb:var(--ion-color-medium-contrast-rgb);--ion-color-shade:var(--ion-color-medium-shade);--ion-color-tint:var(--ion-color-medium-tint)}.ion-color-light{--ion-color-base:var(--ion-color-light);--ion-color-base-rgb:var(--ion-color-light-rgb);--ion-color-contrast:var(--ion-color-light-contrast);--ion-color-contrast-rgb:var(--ion-color-light-contrast-rgb);--ion-color-shade:var(--ion-color-light-shade);--ion-color-tint:var(--ion-color-light-tint)}.ion-color-lighter{--ion-color-base:var(--ion-color-lighter);--ion-color-base-rgb:var(--ion-color-lighter-rgb);--ion-color-contrast:var(--ion-color-lighter-contrast);--ion-color-contrast-rgb:var(--ion-color-lighter-contrast-rgb);--ion-color-shade:var(--ion-color-lighter-shade);--ion-color-tint:var(--ion-color-lighter-tint)}.ion-color-disabled{--ion-color-base:var(--ion-color-disabled);--ion-color-base-rgb:var(--ion-color-disabled-rgb);--ion-color-contrast:var(--ion-color-disabled-contrast);--ion-color-contrast-rgb:var(--ion-color-disabled-contrast-rgb);--ion-color-shade:var(--ion-color-disabled-shade);--ion-color-tint:var(--ion-color-disabled-tint)}.ion-color-outline{--ion-color-base:var(--ion-color-tertiary);--ion-color-base-rgb:var(--ion-color-tertiary-rgb);--ion-color-contrast:var(--ion-color-tertiary-contrast);--ion-color-contrast-rgb:var(--ion-color-tertiary-contrast-rgb);--ion-color-shade:var(--ion-color-tertiary-shade);--ion-color-tint:var(--ion-color-tertiary-tint);border:1px solid var(--ion-color-tertiary-contrast)}.ion-color-outline-disabled{--ion-color-base:var(--ion-color-tertiary);--ion-color-contrast:var(--ion-color-disabled-contrast);border:1px solid var(--ion-color-light)}.dark-theme{--ion-background-color:#1d1d1d;--ion-text-color:#b8b8b8;--ion-backdrop-color:#dadada;--ion-backdrop-opacity:#1d1d1d;--ion-overlay-background-color:#1d1d1d;--ion-border-color:#dadada;--ion-box-shadow-color:#d3d3d3;--ion-tab-bar-background:#1d1d1d;--ion-tab-bar-background-focused:#444;--ion-tab-bar-border-color:#dadada;--ion-tab-bar-color:#dadada;--ion-tab-bar-color-selected:#444;--ion-toolbar-background:#1d1d1d;--ion-toolbar-border-color:#444;--ion-toolbar-color:#dadada;--ion-toolbar-segment-color:#1d1d1d;--ion-toolbar-segment-color-checked:#1d1d1d;--ion-toolbar-segment-background:#1d1d1d;--ion-toolbar-segment-background-checked:#1d1d1d;--ion-toolbar-segment-indicator-color:#1d1d1d;--ion-item-background:#1d1d1d;--ion-item-border-color:#878787;--ion-item-color:#dadada;--ion-placeholder-color:#1d1d1d}.dark-theme,.dark-theme.ios,.dark-theme.md{--ion-footer-background:var(--ion-color-primary)}@font-face{font-family:Roboto;font-style:normal;font-weight:300;src:url(fonts/Roboto-Light.woff) format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:400;src:url(fonts/Roboto-Regular.woff) format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:500;src:url(fonts/Roboto-Medium.woff) format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:700;src:url(fonts/Roboto-Bold.woff) format(\"woff\")}@font-face{font-family:Roboto-Regular;font-style:normal;font-weight:400;src:url(fonts/Roboto-Regular.ttf) format(\"truetype\")}";
styleInject(css_248z$u);

var css_248z$t = ".styles-module_alertClass__Pskut ion-backdrop{--backdrop-opacity:0.6}@media (min-width:1280px){.styles-module_alertClass__Pskut div{--max-width:300px;--width:300px}}";
var styles$q = {"alertClass":"styles-module_alertClass__Pskut"};
styleInject(css_248z$t);

var Alert = function (props) {
    return jsx(IonAlert, __assign({}, props, { cssClass: "".concat(styles$q.alertClass).concat(props.cssClass ? ' ' + props.cssClass : '') }));
};

var css_248z$s = ".styles-module_weekContainer__Uj4Ef{align-items:stretch;display:flex;flex-direction:column}.styles-module_weekContainer__Uj4Ef .styles-module_days__GZRTs{display:flex;justify-content:space-between}.styles-module_weekContainer__Uj4Ef .styles-module_days__GZRTs .styles-module_dayContainer__jfEU4{align-items:center;display:flex;flex-direction:column}.styles-module_weekContainer__Uj4Ef .styles-module_days__GZRTs .styles-module_dayContainer__jfEU4 ion-label{font-size:12px;margin-bottom:12px;padding:0;text-transform:uppercase}.styles-module_weekContainer__Uj4Ef .styles-module_date__iP872{align-items:center;display:flex;flex-direction:row;font-size:16px;justify-content:center;margin-bottom:20px}.styles-module_dayButton__tx95w{--color:#111;--background:#fff;--border-radius:50%;--vertical-align:middle;--padding-start:10px;--padding-end:10px;height:42px;width:42px}.styles-module_dayButton__tx95w.styles-module_available__bg828{--border-color:#0000}.styles-module_dayButton__tx95w.styles-module_notAvailable__gL4vJ{--border-color:#0000;--color:var(--ion-color-disabled-contrast);--opacity:1}.styles-module_dayButton__tx95w.styles-module_full__dyCh4{--color:red;--border-color:#0000}.styles-module_dayButton__tx95w.styles-module_today__bNg36{--border-color:#111;--border-width:1px}.styles-module_dayButton__tx95w.styles-module_selected__oa-lc{--color:#fff;--background:#111;--border-color:#111;--border-width:1px}.styles-module_dayButton__tx95w.styles-module_reserved__7I42C{--color:#111;--background:var(--color-calendarReserved);--border-color:var(--color-calendarReserved);--border-width:1px}.styles-module_dayButton__tx95w.styles-module_homeOffice__sgARX{--color:#111;--background:var(--color-calendarHomeoffice);--border-color:var(--color-calendarHomeoffice);--border-width:1px}";
var styles$p = {"weekContainer":"styles-module_weekContainer__Uj4Ef","days":"styles-module_days__GZRTs","dayContainer":"styles-module_dayContainer__jfEU4","date":"styles-module_date__iP872","dayButton":"styles-module_dayButton__tx95w","available":"styles-module_available__bg828","notAvailable":"styles-module_notAvailable__gL4vJ","full":"styles-module_full__dyCh4","today":"styles-module_today__bNg36","selected":"styles-module_selected__oa-lc","reserved":"styles-module_reserved__7I42C","homeOffice":"styles-module_homeOffice__sgARX"};
styleInject(css_248z$s);

var DayButton$1 = function (_a) {
    var label = _a.label, status = _a.status, day = _a.day, selected = _a.selected, posArray = _a.posArray, onChange = _a.onChange;
    return (jsxs("div", __assign({ className: styles$p.dayContainer }, { children: [jsx(IonLabel, __assign({ className: "ion-padding" }, { children: label })), jsx(IonButton, __assign({ className: "".concat(styles$p.dayButton, " ").concat(selected === day ? styles$p['selected'] : styles$p[status], " "), fill: "outline", size: "small", shape: "round", disabled: status === 'notAvailable', onClick: function () { return onChange(posArray); } }, { children: day }))] })));
};

var weekdays = {
    es: {
        character: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        short: ['DOM', 'LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB'],
        long: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    },
    en: {
        character: ['U', 'M', 'T', 'W', 'R', 'F', 'S'],
        short: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
        long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    },
    pt: {
        character: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        short: ['DOM.', 'SEG.', 'TER.', 'QUA.', 'QUI.', 'SEX.', 'SAB.'],
        long: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
    },
};
var months = {
    es: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ],
    en: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    pt: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
    ],
};

var capitalizeFirstLetter = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var getWeekdayCharacter = function (date, locale) {
    var _a;
    var days = (_a = weekdays[locale]) !== null && _a !== void 0 ? _a : weekdays['es'];
    return days.character[date.getDay()];
};
var getMonthSortString = function (date, locale) {
    return capitalizeFirstLetter(date.toLocaleString(locale, { month: 'short' }));
};
var getCalendarLocale = function (locale) {
    var _a;
    var locales = {
        es: es,
        en: enUS,
        pt: ptBR,
    };
    return (_a = locales[locale]) !== null && _a !== void 0 ? _a : es;
};
var getCalendarLocaleConfig = function (locale) {
    var _a, _b;
    var days = (_a = weekdays[locale]) !== null && _a !== void 0 ? _a : weekdays['es'];
    return {
        weekdaysMin: days.short,
        months: (_b = months[locale]) !== null && _b !== void 0 ? _b : months.es,
        weekdays: days.long,
    };
};

dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
dayjs.extend(isToday);
var WeekCalendar = function (props) {
    var _a = props.locale, locale = _a === void 0 ? 'es' : _a, res = __rest(props, ["locale"]);
    var _b = useState(new Date()), selected = _b[0], setSelected = _b[1];
    var _c = useState([]), reserved = _c[0], setReserved = _c[1];
    var _d = useState([]), homeOffice = _d[0], sethomeOffice = _d[1];
    var _e = useState([]), weekDays = _e[0], setWeekDays = _e[1];
    var _f = useState([]), statusDatesList = _f[0], setStatusDays = _f[1];
    var getThisWeekDates = function (res, home) {
        var weekDates = [];
        var statusDays = [];
        for (var i = 1; i <= 7; i++) {
            var date = dayjs().startOf('isoWeek').day(i);
            weekDates.push(date);
            if (res === null || res === void 0 ? void 0 : res.includes(dayjs(date).format('YYYY-MM-DD'))) {
                statusDays.push('reserved');
            }
            else if (home === null || home === void 0 ? void 0 : home.includes(dayjs(date).format('YYYY-MM-DD'))) {
                statusDays.push('homeOffice');
            }
            else if (date.isToday()) {
                statusDays.push('today');
            }
            else if (date.isBefore(dayjs()) || dayjs(date).day() == 0 || dayjs(date).day() == 6) {
                statusDays.push('notAvailable');
            }
            else {
                statusDays.push('available');
            }
        }
        setStatusDays(statusDays);
        return weekDates;
    };
    useEffect(function () {
        dayjs.locale(locale);
        dayjs.updateLocale(locale, getCalendarLocaleConfig(locale));
        setWeekDays(getThisWeekDates(res.reserved, res.homeOffice));
        res.selected !== undefined && setSelected(res.selected);
        res.reserved !== undefined && setReserved(res.reserved);
        res.homeOffice !== undefined && sethomeOffice(res.homeOffice);
        res.statusDatesList !== undefined && setStatusDays(res.statusDatesList);
    }, [props]);
    var handleClick = function (posArray) {
        var date = new Date(weekDays[posArray].format());
        setSelected(date);
        return res.onChange && res.onChange(date);
    };
    return (jsx(Fragment, { children: jsxs("div", __assign({ className: styles$p.weekContainer }, { children: [jsx("div", __assign({ className: styles$p.date }, { children: dayjs(new Date()).format('MMMM') + ' ' + dayjs(new Date()).year() })), jsx("div", __assign({ className: styles$p.days }, { children: weekDays &&
                        weekDays.map(function (item, i) { return (jsx(DayButton$1, { label: item.locale(locale).format('dd'), day: item.get('date'), selected: selected.getDate(), reserved: reserved, homeOffice: homeOffice, posArray: i, status: statusDatesList[i], onChange: function (posArray) { return handleClick(posArray); } }, item.get('date'))); }) })), res.showDateDescription && (jsx("div", __assign({ className: styles$p.date }, { children: jsx(IonLabel, { children: locale === 'en'
                            ? dayjs(selected).format('dddd D  MMMM  YYYY')
                            : dayjs(selected).format('dddd D [de] MMMM [de] YYYY') }) })))] })) }));
};

var css_248z$r = ".styles-module_weekContainer__WMW24{align-items:stretch;display:flex;flex-direction:column}.styles-module_weekContainer__WMW24 .styles-module_days__JAy-5{display:flex;justify-content:space-between}.styles-module_weekContainer__WMW24 .styles-module_days__JAy-5 .styles-module_dayContainer__bfe-n{align-items:center;display:flex;flex-direction:column}.styles-module_weekContainer__WMW24 .styles-module_days__JAy-5 .styles-module_dayContainer__bfe-n ion-label{font-size:12px;margin-bottom:12px;padding:0;text-transform:uppercase}.styles-module_weekContainer__WMW24 .styles-module_date__HeYdf{align-items:center;display:flex;flex-direction:row;font-size:16px;justify-content:center;margin-bottom:20px}.styles-module_dayButton__yTapF{--color:#111;--background:#fff;--border-radius:50%;--vertical-align:middle;--padding-start:10px;--padding-end:10px;--border-width:1px;--border-color:#0000;font-weight:400;height:42px;position:relative;width:42px}.styles-module_singleDay__PxTJV{position:relative}.styles-module_singleDay__PxTJV .styles-module_month__-DHOw{color:var(--ion-color-disabled-contrast);font-size:11px;left:0;line-height:13px;position:absolute;text-align:center;text-transform:capitalize;top:4px;width:100%}.styles-module_notAvailable__z8oRv{--color:silver;--opacity:1}.styles-module_full__1-6b3{--color:red}.styles-module_today__2RWhk{--border-color:#111;--border-width:1px}.styles-module_reserved__Ad5I0{--background:#beceb7;--border-color:#beceb7;--border-width:1px}.styles-module_homeOffice__-4B8y{--background:#fcd1b3;--border-color:#fcd1b3;--border-width:1px}.styles-module_selected__symnb{--color:#fff;--background:#111;--border-color:#111;--border-width:1px}.styles-module_reservedNonSelectable__YBsIM{--color:silver;--background:#beceb7;--border-color:#beceb7;--border-width:1px}";
var styles$o = {"weekContainer":"styles-module_weekContainer__WMW24","days":"styles-module_days__JAy-5","dayContainer":"styles-module_dayContainer__bfe-n","date":"styles-module_date__HeYdf","dayButton":"styles-module_dayButton__yTapF","singleDay":"styles-module_singleDay__PxTJV","month":"styles-module_month__-DHOw","notAvailable":"styles-module_notAvailable__z8oRv","full":"styles-module_full__1-6b3","today":"styles-module_today__2RWhk","reserved":"styles-module_reserved__Ad5I0","homeOffice":"styles-module_homeOffice__-4B8y","selected":"styles-module_selected__symnb","reservedNonSelectable":"styles-module_reservedNonSelectable__YBsIM"};
styleInject(css_248z$r);

var DayButton = function (_a) {
    var days = _a.days, locale = _a.locale, selected = _a.selected, numDay = _a.numDay, onChange = _a.onChange, classNames = _a.classNames;
    var firstDay = days[0];
    var label = firstDay.date.locale(locale).format('dd');
    var getClassNames = function (singleDay, selected) {
        var isSelected = selected.includes(singleDay.date.format('YYYY-MM-DD'));
        var isHomeOffice = singleDay.isHomeOffice, isNotAvailable = singleDay.isNotAvailable, isReserved = singleDay.isReserved, isToday = singleDay.isToday, isReservedNonSelectable = singleDay.isReservedNonSelectable;
        if (isSelected) {
            return classNames === null || classNames === void 0 ? void 0 : classNames.selected;
        }
        return "".concat(isHomeOffice && (classNames === null || classNames === void 0 ? void 0 : classNames.homeOffice), " ").concat(isNotAvailable && (classNames === null || classNames === void 0 ? void 0 : classNames.notAvailable), " ").concat(isReserved && (classNames === null || classNames === void 0 ? void 0 : classNames.reserved), " ").concat(isReservedNonSelectable && (classNames === null || classNames === void 0 ? void 0 : classNames.reservedNonSelectable), " ").concat(isToday && (classNames === null || classNames === void 0 ? void 0 : classNames.today), " ");
    };
    return (jsxs("div", __assign({ className: styles$o.dayContainer }, { children: [jsx(IonLabel, __assign({ className: "ion-padding" }, { children: label })), days.map(function (dayItem, weekIndex) { return (jsxs("div", __assign({ className: styles$o.singleDay }, { children: [jsx(IonButton, __assign({ className: "".concat(styles$o.dayButton, " ").concat(getClassNames(dayItem, selected), " "), fill: "outline", size: "small", shape: "round", disabled: status === 'notAvailable', onClick: function () { return onChange(numDay, weekIndex); } }, { children: dayItem.date.get('date') })), dayItem.date.get('date') === 1 && jsx("span", __assign({ className: styles$o.month }, { children: dayItem.date.format('MMM') }))] }), dayItem.date.toISOString())); })] })));
};

dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
dayjs.extend(isToday);
var WeekCalendarMultiselector = function (props) {
    var _a = props.locale, locale = _a === void 0 ? 'es' : _a, res = __rest(props, ["locale"]);
    var classNames = res.classNames, selected = res.selected;
    var _b = useState([]), weeksDays = _b[0], setWeeksDays = _b[1];
    var today = new Date();
    var getTheseWeeksDates = function (res, home, weeks) {
        if (weeks === void 0) { weeks = 1; }
        var weeksDates = [];
        if (weeks < 1) {
            weeks = 1;
        }
        var _loop_1 = function (i) {
            // eslint-disable-next-line no-unused-vars
            var datesArray = Array.from(Array(weeks)).map(function (weekDay, indexWeek) {
                var _a, _b;
                var date = dayjs()
                    .startOf('isoWeek')
                    .day(i + 7 * indexWeek);
                var singleDay = {
                    date: date,
                    isHomeOffice: false,
                    isNotAvailable: false,
                    isReserved: false,
                    isToday: false,
                    isReservedNonSelectable: false,
                };
                if (res === null || res === void 0 ? void 0 : res.includes(dayjs(date).format('YYYY-MM-DD'))) {
                    singleDay.isReserved = true;
                }
                else if (home === null || home === void 0 ? void 0 : home.includes(dayjs(date).format('YYYY-MM-DD'))) {
                    singleDay.isHomeOffice = true;
                }
                else if (!((_a = props.reservableDays) === null || _a === void 0 ? void 0 : _a.includes(dayjs(date).format('YYYY-MM-DD')))) {
                    singleDay.isNotAvailable = true;
                }
                else if ((_b = props.reservedNonSelectable) === null || _b === void 0 ? void 0 : _b.includes(dayjs(date).format('YYYY-MM-DD'))) {
                    singleDay.isReservedNonSelectable = true;
                }
                if (date.isToday()) {
                    singleDay.isToday = true;
                }
                return singleDay;
            });
            weeksDates.push(datesArray);
        };
        for (var i = 1; i <= 7; i++) {
            _loop_1(i);
        }
        return weeksDates;
    };
    useEffect(function () {
        dayjs.locale(locale);
        dayjs.updateLocale(locale, getCalendarLocaleConfig(locale));
        setWeeksDays(getTheseWeeksDates(res.reserved, res.homeOffice, res.weeks));
    }, [props]);
    var handleClick = function (posArray, week) {
        var clickedDate = weeksDays[posArray][week];
        return res.onChange && res.onChange(clickedDate.date);
    };
    return (jsx(Fragment, { children: jsxs("div", __assign({ className: styles$o.weekContainer }, { children: [jsx("div", __assign({ className: styles$o.date }, { children: dayjs(today).format('MMMM') + ' ' + dayjs(today).year() })), jsx("div", __assign({ className: styles$o.days }, { children: weeksDays &&
                        weeksDays.map(function (item, i) { return (jsx(DayButton, { classNames: classNames, days: item, locale: locale, selected: selected, numDay: i, onChange: function (numDay, numWeek) { return handleClick(numDay, numWeek); } }, i)); }) })), res.showDateDescription && (jsx("div", __assign({ className: styles$o.date }, { children: jsx(IonLabel, { children: locale === 'en'
                            ? dayjs(today).format('dddd D  MMMM  YYYY')
                            : dayjs(today).format('dddd D [de] MMMM [de] YYYY') }) })))] })) }));
};

var css_248z$q = ".styles-module_button__7j3RT{--border-radius:0px;--box-shadow:none;font-size:15px;font-weight:400;letter-spacing:normal;margin:0 auto}.styles-module_disabled__OKgYy{opacity:1}ion-button{text-transform:none}";
var styles$n = {"button":"styles-module_button__7j3RT","disabled":"styles-module_disabled__OKgYy"};
styleInject(css_248z$q);

var getButtonColor = function (color, disabled) {
    if (disabled && color === 'outline') {
        return 'outline-disabled';
    }
    else if (disabled) {
        return 'disabled';
    }
    else {
        return color;
    }
};
var Button = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'primary' : _b, props = __rest(_a, ["color"]);
    var className = props.className, _c = props.disabled, disabled = _c === void 0 ? false : _c, res = __rest(props, ["className", "disabled"]);
    return (jsx(IonButton, __assign({ className: "".concat(styles$n.button, " ").concat(disabled ? styles$n.disabled : '', " ").concat(className), color: getButtonColor(color, disabled) }, (disabled ? { disabled: true } : {}), res)));
};

var css_248z$p = ".styles-module_input__-Ou1H{color:#000;text-align:right}.styles-module_item__EwuoY{--border-color:silver;--border-color-focused:#000;--highlight-height:0px}.styles-module_item__EwuoY:focus-within{--border-color:#111}";
var styles$m = {"input":"styles-module_input__-Ou1H","item":"styles-module_item__EwuoY"};
styleInject(css_248z$p);

var TextField = function (props) {
    var textLabel = props.textLabel, _a = props.placeholder, placeholder = _a === void 0 ? undefined : _a, res = __rest(props, ["textLabel", "placeholder"]);
    return (jsx(IonItem, __assign({ className: styles$m.item, lines: props.readonly ? 'none' : 'inset' }, { children: jsx(IonInput, __assign({ label: textLabel, className: styles$m.input, placeholder: placeholder === null ? undefined : placeholder }, res)) })));
};

var List = function (props) {
    return jsx(IonList, __assign({}, props));
};

var css_248z$o = ".nice-dates-navigation{align-items:center;color:#333;display:flex;justify-content:space-between;position:relative;text-align:center;text-transform:capitalize}.nice-dates-navigation_current{flex-grow:1;font-size:16px}.nice-dates-navigation_next,.nice-dates-navigation_previous{cursor:pointer;height:0;padding-bottom:14.2857142857%;position:relative;width:14.2857142857%}.nice-dates-navigation_next:before,.nice-dates-navigation_previous:before{border-right:2px solid #999;border-top:2px solid #999;box-sizing:border-box;content:\"\";display:block;height:14px;left:50%;margin-left:-7px;margin-top:-7px;position:absolute;top:50%;transform:rotate(45deg);transition:border-color .2s;width:14px}.nice-dates-navigation_next:hover:before,.nice-dates-navigation_previous:hover:before{border-color:#333}.nice-dates-navigation_next.-disabled,.nice-dates-navigation_previous.-disabled{cursor:default;pointer-events:none}.nice-dates-navigation_next.-disabled:before,.nice-dates-navigation_previous.-disabled:before{border-color:#ddd}.nice-dates-navigation_previous:before{transform:rotate(-135deg)}.nice-dates-week-header{box-shadow:0 1px 0 #0000000f;display:flex;padding:8px 0}.nice-dates-week-header_day{color:#999;font-size:14px;line-height:1;text-align:center;text-transform:uppercase;width:14.2857142857%}.nice-dates-grid{box-sizing:initial;overflow:hidden;position:relative;-webkit-user-select:none;user-select:none}.nice-dates-grid_container{backface-visibility:hidden;display:flex;flex-wrap:wrap;left:0;position:absolute;right:0;transition-property:none;transition-timing-function:cubic-bezier(.4,0,.2,1);will-change:transform}.nice-dates-grid_container.-moving .nice-dates-day_date{transition:color .3s}.nice-dates-grid_container.-origin-bottom{bottom:0;top:auto}.nice-dates-grid_container.-origin-top{bottom:auto;top:0}.nice-dates-grid_container.-transition{transition-property:transform}.nice-dates-day{align-items:center;border-top:1px solid #0000;box-sizing:border-box;color:#333;cursor:pointer;display:flex;flex-direction:column;font-size:14px;justify-content:center;position:relative;text-align:center;width:14.2857142857%}.nice-dates-day_date{transition:color .15s;will-change:color;z-index:3}.nice-dates-day_month{color:#999;font-size:12px;left:0;line-height:1;position:absolute;right:0;text-transform:capitalize;top:10%;z-index:3}.nice-dates-day:after,.nice-dates-day:before{border-radius:999px;bottom:0;box-sizing:border-box;content:\"\";display:block;left:0;opacity:0;position:absolute;right:0;top:0}.nice-dates-day:before{background-color:#333;z-index:1}.nice-dates-day:after{border:2px solid #333;transform:scale(.95);transition-duration:.15s;transition-property:transform,opacity;z-index:2}.nice-dates-day:not(.-disabled):hover:after{opacity:1;transform:scale(1)}@media (hover:none){.nice-dates-day:after{content:none}.nice-dates-day.-selected *{color:#fff}}.nice-dates-day.-selected:before{opacity:1}.nice-dates-day.-selected:hover:after{background-color:#fff}.nice-dates-day.-selected.-disabled *,.nice-dates-day.-selected:not(:hover) *{color:#fff}.nice-dates-day.-selected.-selected-start:before{border-bottom-right-radius:0;border-top-right-radius:0;right:0}.nice-dates-day.-selected.-selected-end:before{border-bottom-left-radius:0;border-top-left-radius:0;left:0}.nice-dates-day.-selected.-selected-middle:before{border-radius:0;left:0;right:0}.nice-dates-day.-selected.-selected-middle:nth-child(7n+1):before{border-bottom-left-radius:2px;border-top-left-radius:2px}.nice-dates-day.-selected.-selected-middle:not(.-end):nth-child(7n):before{border-bottom-right-radius:2px;border-top-right-radius:2px}.nice-dates-day.-today{font-weight:600}.nice-dates-day.-wide:after,.nice-dates-day.-wide:before{left:12.5%;right:12.5%}.nice-dates-day.-outside{color:#999}.nice-dates-day.-disabled{color:#ddd;cursor:default;pointer-events:none}.nice-dates-popover{background-color:#fff;border-radius:8px;box-shadow:0 1px 8px #0000001f;margin:8px 0;max-width:600px;position:absolute;transform:perspective(1000px);transform-origin:top;transition-duration:.4s;transition-property:transform,opacity;transition-timing-function:cubic-bezier(.4,.2,0,1.1);width:100%;will-change:transform,opacity;z-index:9}.nice-dates-popover:not(.-open){opacity:0;pointer-events:none;transform:perspective(1000px) rotateX(-15deg)}";
styleInject(css_248z$o);

var css_248z$n = ".styles-module_today__RDMk5:before{background-color:initial!important;border:1px solid #111;opacity:1!important;transform:none}.styles-module_blockedWarning__i4NKU:before{background-color:#fffde4!important;border:1px solid #fffde4;opacity:1!important;transform:none}.styles-module_blockedInfo__C62b1:before{background-color:#e8e8e8!important;border:1px solid #e8e8e8;opacity:1!important;transform:none}.styles-module_homeOffice__zKN-h:before{background-color:#f8e6cc!important;border:1px solid #f8e6cc;opacity:1!important;transform:none}.styles-module_homeOfficeSelected__Mvdsg:before{background-color:#111!important;border:1px solid #111;opacity:1!important;transform:none}";
var style = {"today":"styles-module_today__RDMk5","blockedWarning":"styles-module_blockedWarning__i4NKU","blockedInfo":"styles-module_blockedInfo__C62b1","homeOffice":"styles-module_homeOffice__zKN-h","homeOfficeSelected":"styles-module_homeOfficeSelected__Mvdsg"};
styleInject(css_248z$n);

dayjs.extend(isToday);
var MultipleDaysCalendar = function (props) {
    var _a = useState(props.selectedDates || []), selectedDates = _a[0], setSelectedDates = _a[1];
    var _b = useState({}), modifiers = _b[0], setModifiers = _b[1];
    var _c = useState({}), modifiersClass = _c[0], setModifiersClass = _c[1];
    var handleDayClick = function (date) {
        var _a, _b;
        if ((_a = props.blockedDays) === null || _a === void 0 ? void 0 : _a.includes(dayjs(date).format('YYYY-MM-DD'))) {
            props.onClickBlockedDay && props.onClickBlockedDay(date);
        }
        else {
            if ((_b = props.homeOffice) === null || _b === void 0 ? void 0 : _b.includes(dayjs(date).format('YYYY-MM-DD'))) {
                props.onClickHomeOfficeDay && props.onClickHomeOfficeDay(date);
                if (!props.homeOfficeReservationAvailable)
                    return;
            }
            if (selectedDates.length != 0) {
                if (!selectedDates.some(function (selectedDate) { return dayjs(selectedDate).isSame(dayjs(date), 'day'); })) {
                    setSelectedDates(__spreadArray(__spreadArray([], selectedDates, true), [date], false));
                    props.selectedDate(__spreadArray(__spreadArray([], selectedDates, true), [date], false));
                }
                else {
                    var filterDate = selectedDates.filter(function (selectDate) { return !dayjs(selectDate).isSame(dayjs(date), 'day'); });
                    setSelectedDates(filterDate);
                    props.selectedDate(filterDate);
                }
            }
            else {
                setSelectedDates(__spreadArray(__spreadArray([], selectedDates, true), [date], false));
                props.selectedDate(__spreadArray(__spreadArray([], selectedDates, true), [date], false));
            }
        }
    };
    useEffect(function () {
        setModifiers(__assign({ selected: function (date) {
                return selectedDates.some(function (selectedDate) { return dayjs(selectedDate).isSame(dayjs(date), 'day'); });
            }, today: function (date) {
                return dayjs(date).isToday() &&
                    !selectedDates.some(function (selectedDate) { return dayjs(selectedDate).isSame(dayjs(date), 'day'); });
            }, homeOfficeSelected: function (date) {
                var _a;
                return ((_a = props.homeOffice) === null || _a === void 0 ? void 0 : _a.includes(dayjs(date).format('YYYY-MM-DD'))) &&
                    selectedDates.some(function (selectedDate) { return dayjs(selectedDate).isSame(dayjs(date), 'day'); });
            } }, props.moreModifiers));
        setModifiersClass(__assign({ today: style.today, blockedWarning: style.blockedWarning, blockedInfo: style.blockedInfo, homeOffice: style.homeOffice, homeOfficeSelected: style.homeOfficeSelected }, props.moreModifiersClassNames));
    }, [props]);
    return (jsx(Calendar, { modifiersClassNames: modifiersClass, onDayClick: handleDayClick, modifiers: modifiers, minimumDate: props.minimumDate, maximumDate: props.maximumDate, locale: getCalendarLocale(props.locale) }));
};

var css_248z$m = ".nice-dates-navigation{align-items:center;color:#333;display:flex;justify-content:space-between;position:relative;text-align:center;text-transform:capitalize}.nice-dates-navigation_current{flex-grow:1;font-size:16px}.nice-dates-navigation_next,.nice-dates-navigation_previous{cursor:pointer;height:0;padding-bottom:14.2857142857%;position:relative;width:14.2857142857%}.nice-dates-navigation_next:before,.nice-dates-navigation_previous:before{border-right:2px solid #999;border-top:2px solid #999;box-sizing:border-box;content:\"\";display:block;height:14px;left:50%;margin-left:-7px;margin-top:-7px;position:absolute;top:50%;transform:rotate(45deg);transition:border-color .2s;width:14px}.nice-dates-navigation_next:hover:before,.nice-dates-navigation_previous:hover:before{border-color:#333}.nice-dates-navigation_next.-disabled,.nice-dates-navigation_previous.-disabled{cursor:default;pointer-events:none}.nice-dates-navigation_next.-disabled:before,.nice-dates-navigation_previous.-disabled:before{border-color:#ddd}.nice-dates-navigation_previous:before{transform:rotate(-135deg)}.nice-dates-week-header{box-shadow:0 1px 0 #0000000f;display:flex;padding:8px 0}.nice-dates-week-header_day{color:#333;font-size:14px;line-height:1;text-align:center;text-transform:uppercase;width:14.2857142857%}.nice-dates-grid{box-sizing:initial;overflow:hidden;position:relative;-webkit-user-select:none;user-select:none}.nice-dates-grid_container{backface-visibility:hidden;display:flex;flex-wrap:wrap;left:0;position:absolute;right:0;transition-property:none;transition-timing-function:cubic-bezier(.4,0,.2,1);will-change:transform}.nice-dates-grid_container.-moving .nice-dates-day_date{transition:color .3s}.nice-dates-grid_container.-origin-bottom{bottom:0;top:auto}.nice-dates-grid_container.-origin-top{bottom:auto;top:0}.nice-dates-grid_container.-transition{transition-property:transform}.nice-dates-day{align-items:center;border-top:1px solid #0000;box-sizing:border-box;color:#333;cursor:pointer;display:flex;flex-direction:column;font-size:14px;justify-content:center;position:relative;text-align:center;width:14.2857142857%}.nice-dates-day_date{transition:color .15s;will-change:color;z-index:3}.nice-dates-day_month{color:#999;font-size:12px;left:0;line-height:1;position:absolute;right:0;text-transform:capitalize;top:10%;z-index:3}.nice-dates-day:after,.nice-dates-day:before{border-radius:999px;bottom:0;box-sizing:border-box;content:\"\";display:block;left:0;opacity:0;position:absolute;right:0;top:0}.nice-dates-day:before{background-color:#333;z-index:1}.nice-dates-day:after{border:2px solid #333;transform:scale(.95);transition-duration:.15s;transition-property:transform,opacity;z-index:2}.nice-dates-day:not(.-disabled):hover:after{opacity:1;transform:scale(1)}@media (hover:none){.nice-dates-day:after{content:none}.nice-dates-day.-selected *{color:#fff}}.nice-dates-day.-selected:before{opacity:1}.nice-dates-day.-selected:hover:after{background-color:#fff}.nice-dates-day.-selected.-disabled *,.nice-dates-day.-selected:not(:hover) *{color:#fff}.nice-dates-day.-selected.-selected-start:before{border-bottom-right-radius:0;border-top-right-radius:0;right:0}.nice-dates-day.-selected.-selected-end:before{border-bottom-left-radius:0;border-top-left-radius:0;left:0}.nice-dates-day.-selected.-selected-middle:before{border-radius:0;left:0;right:0}.nice-dates-day.-selected.-selected-middle:nth-child(7n+1):before{border-bottom-left-radius:2px;border-top-left-radius:2px}.nice-dates-day.-selected.-selected-middle:not(.-end):nth-child(7n):before{border-bottom-right-radius:2px;border-top-right-radius:2px}.nice-dates-day.-today{font-weight:600}.nice-dates-day.-wide:after,.nice-dates-day.-wide:before{left:12.5%;right:12.5%}.nice-dates-day.-outside{color:#999}.nice-dates-day.-disabled{color:#ddd;cursor:default;pointer-events:none}.nice-dates-popover{background-color:#fff;border-radius:8px;box-shadow:0 1px 8px #0000001f;margin:8px 0;max-width:600px;position:absolute;transform:perspective(1000px);transform-origin:top;transition-duration:.4s;transition-property:transform,opacity;transition-timing-function:cubic-bezier(.4,.2,0,1.1);width:100%;will-change:transform,opacity;z-index:9}.nice-dates-popover:not(.-open){opacity:0;pointer-events:none;transform:perspective(1000px) rotateX(-15deg)}";
styleInject(css_248z$m);

var css_248z$l = ".styles-module_today__f4Zh-:before{background-color:initial;border:1px solid #111;opacity:1;transform:none}.styles-module_todaySelected__vA8P-:before{background-color:#111;border:1px solid #111;opacity:1;transform:none}.styles-module_blockedWarning__uGm2F:before{background-color:#fffde4;border:1px solid #fffde4;opacity:1;transform:none}.styles-module_blockedInfo__94MFz:before{background-color:#e8e8e8;border:1px solid #e8e8e8;opacity:1;transform:none}.styles-module_homeOffice__Kuemw:before{background-color:#f8e6cc;border:1px solid #f8e6cc;opacity:1;transform:none}.styles-module_homeOfficeSelected__-MR9h:before{background-color:#111;border:1px solid #111;opacity:1;transform:none}.styles-module_reservedDays__QIXgF:before{background-color:var(--ion-color-octonary);border:1px solid var(--ion-color-octonary);opacity:1;transform:none}.styles-module_reservedDaysSelected__FubDY:before{background-color:#111;border:1px solid #111;opacity:1;transform:none}";
var styles$l = {"today":"styles-module_today__f4Zh-","todaySelected":"styles-module_todaySelected__vA8P-","blockedWarning":"styles-module_blockedWarning__uGm2F","blockedInfo":"styles-module_blockedInfo__94MFz","homeOffice":"styles-module_homeOffice__Kuemw","homeOfficeSelected":"styles-module_homeOfficeSelected__-MR9h","reservedDays":"styles-module_reservedDays__QIXgF","reservedDaysSelected":"styles-module_reservedDaysSelected__FubDY"};
styleInject(css_248z$l);

dayjs.extend(isToday);
var defaultModifiersClassNames = {
    today: styles$l.today,
    todaySelected: styles$l.todaySelected,
    blockedWarning: styles$l.reservedDays,
    blockedInfo: styles$l.reservedDays,
    homeOffice: styles$l.homeOffice,
    homeOfficeSelected: styles$l.homeOfficeSelected,
    reservedDays: styles$l.reservedDays,
    reservedDaysSelected: styles$l.reservedDaysSelected,
};
var PickerCalendar = function (props) {
    var _a = useState(true), delayed = _a[0], setDelayed = _a[1];
    var _b = useState({}), modifiers = _b[0], setModifiers = _b[1];
    useEffect(function () {
        var timeout = setTimeout(function () {
            setDelayed(false);
        }, 300);
        return function () {
            clearTimeout(timeout);
        };
    }, []);
    useEffect(function () {
        var nextModifiers = __assign({ today: function (date) { return dayjs(date).isToday() && !dayjs(props.date).isSame(dayjs(date), 'day'); }, todaySelected: function (date) { return dayjs(date).isToday() && dayjs(props.date).isSame(dayjs(date), 'day'); }, disabled: function (date) { return getDay(date) === 6 || getDay(date) === 0; }, homeOfficeSelected: function (date) {
                var _a;
                return ((_a = props.homeOffice) === null || _a === void 0 ? void 0 : _a.includes(dayjs(date).format('YYYY-MM-DD'))) &&
                    dayjs(props.date).isSame(dayjs(date), 'day');
            }, reservedDaysSelected: function (date) { var _a; return ((_a = props.reserved) === null || _a === void 0 ? void 0 : _a.includes(dayjs(date).format('YYYY-MM-DD'))) && dayjs(props.date).isSame(dayjs(date), 'day'); }, homeOffice: function (date) {
                var _a;
                return ((_a = props.homeOffice) === null || _a === void 0 ? void 0 : _a.includes(dayjs(date).format('YYYY-MM-DD'))) &&
                    !dayjs(props.date).isSame(dayjs(date), 'day');
            }, reservedDays: function (date) { var _a; return ((_a = props.reserved) === null || _a === void 0 ? void 0 : _a.includes(dayjs(date).format('YYYY-MM-DD'))) && !dayjs(props.date).isSame(dayjs(date), 'day'); } }, ((props === null || props === void 0 ? void 0 : props.moreModifiers) ? props.moreModifiers : {}));
        setModifiers(nextModifiers);
    }, [props.date, props.homeOffice, props.reserved, props.moreModifiers]);
    var modifiersClassNames = __assign(__assign({}, defaultModifiersClassNames), ((props === null || props === void 0 ? void 0 : props.moreModifiersClassNames) ? props.moreModifiersClassNames : {}));
    return (jsx("div", { children: !delayed && (jsx(DatePickerCalendar, { date: props.date, minimumDate: props.minimumDate, maximumDate: props.maximumDate, modifiersClassNames: modifiersClassNames, onDateChange: props.selectedDate, locale: getCalendarLocale(props.locale), modifiers: modifiers })) }));
};

var RangeCalendar = function (props) {
    var _a = useState(props.minimumDate), startDate = _a[0], setStartDate = _a[1];
    var _b = useState(props.minimumDate), endDate = _b[0], setEndDate = _b[1];
    var _c = useState('endDate'), focus = _c[0], setFocus = _c[1];
    var _d = useState(false), mounted = _d[0], setMounted = _d[1];
    var handleDayClick = function (date) {
        if (focus == 'startDate') {
            props.onSelectDates([date, date]);
            setStartDate(date);
            setEndDate(date);
        }
        else {
            if (date < startDate) {
                props.onSelectDates([date, date]);
                setStartDate(date);
                setFocus('startDate');
            }
            else {
                props.onSelectDates([startDate, date]);
            }
            setEndDate(date);
        }
    };
    var handleFocusChange = function (newFocus) {
        setFocus(newFocus || 'startDate');
    };
    useEffect(function () {
        new Promise(function (r) { return setTimeout(function () { return r(length); }, 300); }).then(function () { return setMounted(true); });
    }, [mounted]);
    // startDate?: Date;
    // endDate?: Date;
    // focus?: DateRangeFocus;
    // month?: Date;
    // minimumLength?: number;
    // maximumLength?: number;
    // onFocusChange?: (focus: DateRangeFocus) => void;
    // onStartDateChange?: DateChangeCallBack;
    // onEndDateChange?: DateChangeCallBack;
    // onMonthChange?: DateChangeCallBack;
    return (jsx("div", { children: mounted && (jsx(DateRangePickerCalendar, { focus: focus, startDate: startDate, endDate: endDate, onStartDateChange: handleDayClick, onEndDateChange: handleDayClick, minimumDate: props.minimumDate, maximumDate: props.maximumDate, locale: es, onFocusChange: handleFocusChange })) }));
};

var css_248z$k = ".styles-module_checkedSquare__SyPGA,.styles-module_disabledCheckedSquare__OGlbM,.styles-module_homeOfficeSquare__xy-xm,.styles-module_nonCheckedSquare__dNJSP{--background:#fff;--border-width:1px;--border-style:solid;--border-color:#e5e5e5;--border-radius:3px;--background-activated:#0000;height:48px;margin-right:8px;opacity:1;width:48px}.styles-module_disabledCheckedSquare__OGlbM{--background:#fff;--border-color:#e5e5e5}.styles-module_homeOfficeSquare__xy-xm{--background:var(--color-calendarHomeoffice);--border-color:var(--color-calendarHomeoffice)}.styles-module_nonCheckedSquare__dNJSP{--background:#fff;--border-color:#111}.styles-module_checkedSquare__SyPGA{--background:#111;--border-color:#111}.styles-module_disabledCheckedSquare__OGlbM p{color:#111!important}.styles-module_checkedSquare__SyPGA p{color:#fff!important}.styles-module_textDown__95hlI,.styles-module_textUp__9b7DX{font-size:12px;line-height:14px;margin:0 auto;text-align:center}.styles-module_textDown__95hlI{letter-spacing:normal}.styles-module_noPadding__JogTT{display:flex;flex-direction:column;height:32px;justify-content:space-between;padding:0;width:48px}";
var styles$k = {"disabledCheckedSquare":"styles-module_disabledCheckedSquare__OGlbM","homeOfficeSquare":"styles-module_homeOfficeSquare__xy-xm","nonCheckedSquare":"styles-module_nonCheckedSquare__dNJSP","checkedSquare":"styles-module_checkedSquare__SyPGA","textUp":"styles-module_textUp__9b7DX","textDown":"styles-module_textDown__95hlI","noPadding":"styles-module_noPadding__JogTT"};
styleInject(css_248z$k);

var DayCalendar = function (props) {
    var _a;
    var _b = useState(props.selected), activated = _b[0], setActivated = _b[1];
    var locale = (_a = props === null || props === void 0 ? void 0 : props.locale) !== null && _a !== void 0 ? _a : 'es';
    var weekday = getWeekdayCharacter(props.date, locale);
    var month = getMonthSortString(props.date, locale);
    var dayNumber = props.date.getDate();
    var changeState = function () {
        if (!props.disabled || !props.homeOffice) {
            setActivated(!activated);
            return props.onChange && props.onChange({ status: !activated, id: props.id });
        }
    };
    useEffect(function () {
        setActivated(props.selected);
    }, [props.selected]);
    return (jsx(IonButton, __assign({ fill: "outline", disabled: props.disabled, className: activated
            ? styles$k.checkedSquare
            : props.homeOffice
                ? styles$k.homeOfficeSquare
                : props.disabled
                    ? styles$k.disabledCheckedSquare
                    : styles$k.nonCheckedSquare, onClick: changeState }, { children: jsxs(IonGrid, __assign({ className: styles$k.noPadding }, { children: [jsx(IonRow, { children: jsx("p", __assign({ className: styles$k.textUp }, { children: weekday })) }), jsx(IonRow, { children: jsxs("p", __assign({ className: styles$k.textDown }, { children: [dayNumber, " ", month] })) })] })) })));
};

var css_248z$j = ".styles-module_active__6Uy50{background:var(--ion-color-primary);color:var(--ion-color-primary-contrast)}.styles-module_active__6Uy50,.styles-module_nonActive__PYyPx{border-color:var(--ion-color-primary);border-radius:20px;line-height:inherit}.styles-module_nonActive__PYyPx{background:var(--ion-color-primary-contrast);color:var(--ion-color-primary)}";
var styles$j = {"active":"styles-module_active__6Uy50","nonActive":"styles-module_nonActive__PYyPx"};
styleInject(css_248z$j);

var FilterChip = function (props) {
    var text = props.text, icon = props.icon, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.checked, checked = _b === void 0 ? false : _b, id = props.id, res = __rest(props, ["text", "icon", "disabled", "checked", "id"]);
    var _c = useState(false), activated = _c[0], setActivated = _c[1];
    useEffect(function () {
        !disabled && setActivated(checked);
    }, [checked]);
    var changeState = function () {
        return res.onChange && res.onChange({ checked: checked, id: id });
    };
    return (jsxs(IonChip, __assign({ id: id, outline: true, className: activated ? styles$j.active : styles$j.nonActive, onClick: changeState }, { children: [icon && jsx(IonIcon, { className: icon, color: "".concat(activated && 'light') }), jsx(IonLabel, { children: text })] })));
};

var css_248z$i = ".styles-module_base__2AIVI{--width:100%;--height:auto;--color:var(--ion-color-primary);--background:var(--ion-color-tertiary);--box-shadow:0px -4px 12px #69696914;--border-radius:30px 30px 0px 0px;--start:0px;--padding-inline:0px;font-size:13px;line-height:18px;transform:translateY(10px)!important}.styles-module_base__2AIVI::part(button){font-size:24px;font-weight:400;margin-top:14px;padding-right:0;padding-top:0}.styles-module_base__2AIVI::part(message){padding-right:0;padding-top:0}.styles-module_base__2AIVI::part(container){align-items:flex-start;padding:10px 16px 26px}.styles-module_base__2AIVI::part(content){padding:0}.styles-module_homeOffice__WJQzY{--background:var(--ion-color-septenary)}.styles-module_success__Idrwz{--button-color:var(--ion-color-success)}.styles-module_info__9nP5E{--button-color:var(--ion-color-primary)}.styles-module_warning__EB4zZ{--button-color:var(--ion-color-warning)}.styles-module_error__sdgqs{--button-color:var(--ion-color-secondary)}";
var styles$i = {"base":"styles-module_base__2AIVI","homeOffice":"styles-module_homeOffice__WJQzY","success":"styles-module_success__Idrwz","info":"styles-module_info__9nP5E","warning":"styles-module_warning__EB4zZ","error":"styles-module_error__sdgqs"};
styleInject(css_248z$i);

var classes$3 = {
    success: "".concat(styles$i.success),
    info: "".concat(styles$i.info),
    warning: "".concat(styles$i.warning),
    error: "".concat(styles$i.error),
    homeOffice: "".concat(styles$i.homeOffice),
};

/* Ionicons v7.3.1, ES Modules */
const add = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' d='M256 112v288M400 256H112' class='ionicon-fill-none ionicon-stroke-width'/></svg>";
const checkmark = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' d='M416 128L192 384l-96-96' class='ionicon-fill-none ionicon-stroke-width'/></svg>";
const checkmarkOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' d='M416 128L192 384l-96-96' class='ionicon-fill-none ionicon-stroke-width'/></svg>";
const closeOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' d='M368 368L144 144M368 144L144 368' class='ionicon-fill-none ionicon-stroke-width'/></svg>";
const warningOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/><path d='M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/><path d='M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z'/></svg>";

var iconInfo = 'data:image/svg+xml;base64,' +
    btoa("\n  <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"#111111\">\n    <g clip-path=\"url(#clip0_683_2603)\">\n      <path d=\"M12.5791 5.79102C12.5791 6.24561 12.2173 6.60742 11.772 6.60742C11.3174 6.60742 10.9556 6.24561 10.9556 5.79102C10.9556 5.33643 11.3174 4.98389 11.772 4.98389C12.2173 4.98389 12.5791 5.33643 12.5791 5.79102Z\" fill=\"#111111\"/>\n      <path d=\"M12.3843 18H11.1504V8.35156H12.3843V18Z\" fill=\"#111111\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z\" fill=\"#111111\"/>\n    </g>\n    <defs>\n      <clipPath id=\"clip0_683_2603\">\n        <rect width=\"24\" height=\"24\" fill=\"white\"/>\n      </clipPath>\n    </defs>\n  </svg>\n");

var typeIconMessage = {
    success: [
        {
            side: 'start',
            icon: checkmarkOutline, //el icono de ionc
        },
    ],
    info: [
        {
            side: 'start',
            icon: iconInfo, //el icono de ionc
        },
    ],
    warning: [
        {
            side: 'start',
            icon: warningOutline, //el icono de ionc
        },
    ],
    error: [
        {
            side: 'start',
            icon: closeOutline, //el icono de ionc
        },
    ],
    homeOffice: [
        {
            side: 'start',
            icon: iconInfo, //el icono de ionc
        },
    ],
};
var defaultDuration = 5000;
var Toast = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'success' : _b, props = __rest(_a, ["type"]);
    var duration = props.duration, res = __rest(props, ["duration"]);
    return (jsx(IonToast, __assign({}, res, { cssClass: "".concat(styles$i.base, " ").concat(classes$3[type], " ").concat(res.cssClass), buttons: typeIconMessage[type], duration: duration !== null && duration !== void 0 ? duration : defaultDuration })));
};

var SegmentButton = function (props) {
    return jsx(IonSegmentButton, __assign({}, props));
};

var CardHeader = function (props) {
    return jsx(IonCardHeader, __assign({}, props));
};

var CardContent = function (props) {
    return jsx(IonCardContent, __assign({}, props));
};

var Card = function (props) {
    return jsx(IonCard, __assign({}, props));
};

var CardSubtitle = function (props) {
    return jsx(IonCardSubtitle, __assign({}, props));
};

var CardTitle = function (props) {
    return jsx(IonCardTitle, __assign({}, props));
};

var css_248z$h = ".styles-module_lblSty__ntNx5{border-radius:2px;color:#fff;font-size:12px;font-style:normal;font-weight:400;height:24px;letter-spacing:0;line-height:16px;margin:0;padding:0 5px}.styles-module_lblSty__ntNx5 ion-icon{color:#fff;font-size:16px}.styles-module_success__ejbhF{background-color:#4bd27f}.styles-module_info__1rr74{background-color:#111}.styles-module_warning__m-dwU{background-color:#fcaa4a}.styles-module_error__la0CO{background-color:red}.styles-module_light__qWNBx{background-color:silver}.styles-module_soft__h9t9g{background-color:#f5f5f5;color:#111}";
var styles$h = {"lblSty":"styles-module_lblSty__ntNx5","success":"styles-module_success__ejbhF","info":"styles-module_info__1rr74","warning":"styles-module_warning__m-dwU","error":"styles-module_error__la0CO","light":"styles-module_light__qWNBx","soft":"styles-module_soft__h9t9g"};
styleInject(css_248z$h);

var classes$2 = {
    success: "".concat(styles$h.lblSty, " ").concat(styles$h.success),
    info: "".concat(styles$h.lblSty, " ").concat(styles$h.info),
    warning: "".concat(styles$h.lblSty, " ").concat(styles$h.warning),
    error: "".concat(styles$h.lblSty, " ").concat(styles$h.error),
    light: "".concat(styles$h.lblSty, " ").concat(styles$h.light),
    soft: "".concat(styles$h.lblSty, " ").concat(styles$h.soft),
};

// import styles from './styles.module.scss';
var Chip = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'info' : _b, props = __rest(_a, ["type"]);
    var className = props.className, res = __rest(props, ["className"]);
    return jsx(IonChip, __assign({}, res, { className: "".concat(classes$2[type], "  ").concat(className) }));
};

var css_248z$g = ".styles-module_progBarSt__n2UwB{height:4px;width:100%}.styles-module_progBarSt__n2UwB::part(track){background:#e5e5e5}";
var styles$g = {"progBarSt":"styles-module_progBarSt__n2UwB"};
styleInject(css_248z$g);

var ProgressBar = function (props) {
    return jsx(IonProgressBar, __assign({}, props, { className: styles$g.progBarSt }));
};

var css_248z$f = "@media (min-width:1024px){.styles-module_modalSty__sKhhl{--width:800px;--height:450px}}@media (min-width:1920px){.styles-module_modalSty__sKhhl{--width:1200px;--height:675px}}";
var styles$f = {"modalSty":"styles-module_modalSty__sKhhl"};
styleInject(css_248z$f);

var Modal = function (props) {
    var cssClass = props.cssClass, res = __rest(props, ["cssClass"]);
    return jsx(IonModal, __assign({ className: "".concat(styles$f.modalSty, " ").concat(cssClass) }, res));
};

var css_248z$e = ".styles-module_snackBar__3vBjC{align-items:center;display:flex;width:100%}@media (min-width:1024px){.styles-module_snackBar__3vBjC{justify-content:center}}.styles-module_snackBarContainer__kycyr{--min-height:38px;padding:0 16px}.styles-module_snackBarContainer__kycyr::part(native){--inner-padding-end:0px;--padding-end:0px;align-items:center;background-color:initial;display:flex;flex-direction:row;justify-content:flex-start;margin:0;padding:0;padding-inline-end:0;width:100%}.styles-module_admin__hUWzf .styles-module_snackBarIconSty__QwXr2{align-self:center}.styles-module_admin__hUWzf .styles-module_snackBarTxtSty__rr7LY{font-size:13px}.styles-module_snackBarIconSty__QwXr2{align-self:flex-start;font-size:24px;margin:12px 8px 12px 0;padding-top:1px}.styles-module_snackBarTxtSty__rr7LY{font-size:12px;font-style:normal;font-weight:400;height:auto;letter-spacing:0;line-height:16px;padding:12px 0;text-align:left;width:100%}.styles-module_snackBarTxtSty__rr7LY ion-router-link{color:var(--ion-color-secondary)}.styles-module_bgWhite__G7wtM{background-color:var(--ion-color-tertiary)}.styles-module_bgSuccess__wvRF5{background-color:#edfbf2}.styles-module_bgInfo__bevQd{background-color:var(--ion-color-lighter)}.styles-module_bgWarning__BHMqx{background-color:#ffedbf}.styles-module_bgError__ZpcT1{background-color:#fff0f0}.styles-module_success__jLsvB{color:var(--ion-color-success)}.styles-module_info__OF1je,.styles-module_white__WzEPy{color:var(--ion-color-primary)}.styles-module_warning__SecSC{color:var(--ion-color-warning)}.styles-module_error__CnepC{color:var(--ion-color-secondary)}.styles-module_center__G-QqK{margin:0 auto}.styles-module_left__5dzcM{margin:0}";
var styles$e = {"snackBar":"styles-module_snackBar__3vBjC","snackBarContainer":"styles-module_snackBarContainer__kycyr","admin":"styles-module_admin__hUWzf","snackBarIconSty":"styles-module_snackBarIconSty__QwXr2","snackBarTxtSty":"styles-module_snackBarTxtSty__rr7LY","bgWhite":"styles-module_bgWhite__G7wtM","bgSuccess":"styles-module_bgSuccess__wvRF5","bgInfo":"styles-module_bgInfo__bevQd","bgWarning":"styles-module_bgWarning__BHMqx","bgError":"styles-module_bgError__ZpcT1","success":"styles-module_success__jLsvB","info":"styles-module_info__OF1je","white":"styles-module_white__WzEPy","warning":"styles-module_warning__SecSC","error":"styles-module_error__CnepC","center":"styles-module_center__G-QqK","left":"styles-module_left__5dzcM"};
styleInject(css_248z$e);

var snackBarClasses = {
    success: "".concat(styles$e.bgSuccess),
    info: "".concat(styles$e.bgInfo),
    warning: "".concat(styles$e.bgWarning),
    error: "".concat(styles$e.bgError),
    white: "".concat(styles$e.bgWhite),
};
var classes$1 = {
    success: "".concat(styles$e.success),
    info: "".concat(styles$e.info),
    warning: "".concat(styles$e.warning),
    error: "".concat(styles$e.error),
    white: "".concat(styles$e.white),
};
var aligns = {
    left: "".concat(styles$e.left),
    center: "".concat(styles$e.center),
};

var Icon = function (props) {
    return jsx(IonIcon, __assign({}, props));
};

var Snackbar = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'success' : _b, text = _a.text, icon = _a.icon, _c = _a.align, align = _c === void 0 ? 'left' : _c, _d = _a.mode, mode = _d === void 0 ? 'user' : _d, children = _a.children;
    return (jsx("div", __assign({ className: "".concat(styles$e.snackBar, " ").concat(snackBarClasses[type], " ").concat(mode === 'admin' ? styles$e.admin : '') }, { children: jsxs(IonItem, __assign({ lines: "none", className: "".concat(styles$e.snackBarContainer, " ").concat(aligns[align]) }, { children: [icon && jsx(Icon, { slot: "start", className: "".concat(styles$e.snackBarIconSty, " ").concat(classes$1[type], " ").concat(icon) }), jsx(IonText, __assign({ className: styles$e.snackBarTxtSty }, { children: text })), children] })) })));
};

var css_248z$d = ".styles-module_listItemSty__ADpuT{display:flex;flex-direction:row;height:50px;justify-content:space-around;width:100%}.styles-module_itemSty__WNXI1{--min-height:24px;--padding-start:0px;--padding-end:0px;--inner-padding-end:0px;--inner-padding-start:0px;justify-content:space-around;margin:0 auto;padding:0}.styles-module_itemIconSty__WRNE2{margin-right:5px;padding-top:2px}.styles-module_itemTxtSty__KmVQR{color:#696969;font-size:12px}";
var styles$d = {"listItemSty":"styles-module_listItemSty__ADpuT","itemSty":"styles-module_itemSty__WNXI1","itemIconSty":"styles-module_itemIconSty__WRNE2","itemTxtSty":"styles-module_itemTxtSty__KmVQR"};
styleInject(css_248z$d);

var SocialToolBarItem = function (_a) {
    var text = _a.text, icon = _a.icon, props = __rest(_a, ["text", "icon"]);
    var className = props.className, res = __rest(props, ["className"]);
    return (jsxs(IonItem, __assign({ lines: "none" }, res, { className: "".concat(styles$d.itemSty, " ").concat(className) }, { children: [jsx(IonIcon, { className: "".concat(styles$d.itemIconSty, " ").concat(icon) }), jsx(IonText, __assign({ className: styles$d.itemTxtSty }, { children: text }))] })));
};

var css_248z$c = ".styles-module_searchBarSty__iKcE-{--background:var(--ion-color-lighter)!important;--icon-color:#000!important;--cancel-button-color:#007aff!important;--border-radius:34px!important;font-size:17px!important}.styles-module_searchBarSty__iKcE- input{padding-left:46px!important;padding-right:46px!important}.styles-module_searchBarSty__iKcE- ion-icon{margin-left:10px!important}.styles-module_searchBarSty__iKcE- button{color:#000!important;margin-right:15px!important}.styles-module_searchbar-cancel-button__i3ErN.styles-module_sc-ion-searchbar-ios__h-fDm{font-size:17px!important;line-height:22px}";
var styles$c = {"searchBarSty":"styles-module_searchBarSty__iKcE-","searchbar-cancel-button":"styles-module_searchbar-cancel-button__i3ErN","sc-ion-searchbar-ios":"styles-module_sc-ion-searchbar-ios__h-fDm"};
styleInject(css_248z$c);

var SearchBar = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (jsx(IonSearchbar, __assign({ mode: "ios", className: "".concat(styles$c.searchBarSty, " ").concat(className), clearIcon: "close-sharp" }, rest)));
};

var ListHeader = function (props) {
    return jsx(IonListHeader, __assign({}, props));
};

var css_248z$b = ".styles-module_item__1xxWZ::part(detail-icon){color:#000;font-size:24px;opacity:.75}";
var styles$b = {"item":"styles-module_item__1xxWZ"};
styleInject(css_248z$b);

var Item = function (props) {
    var className = props.className, res = __rest(props, ["className"]);
    return jsx(IonItem, __assign({}, res, { className: "".concat(styles$b.item, " ").concat(className) }));
};

var ActionSheet = function (props) {
    return jsx(IonActionSheet, __assign({}, props));
};

var css_248z$a = ".styles-module_clusterButtonSty__ibsNL{--background-checked:#111;--color:#111;--indicator-color:#0000;--color-checked:#fff;border-top:1px solid #e5e5e5;display:flex;flex-direction:column;height:60px;justify-content:center;max-width:85px;min-width:85px}@media (min-width:1280px){.styles-module_clusterButtonSty__ibsNL{max-width:196px}}.styles-module_clusterButtonSty__ibsNL ion-label:first-child{font-size:11px;font-style:normal;font-weight:400;line-height:13px;margin-bottom:4px;margin-top:0;text-transform:capitalize}.styles-module_clusterButtonSty__ibsNL ion-label:nth-child(2){font-size:17px;font-style:normal;font-weight:600;line-height:22px;margin-bottom:0;margin-top:0}";
var styles$a = {"clusterButtonSty":"styles-module_clusterButtonSty__ibsNL"};
styleInject(css_248z$a);

var ClusterButton = function (props) {
    var className = props.className, res = __rest(props, ["className"]);
    return (jsxs(IonSegmentButton, __assign({ className: "".concat(styles$a.clusterButtonSty, " ").concat(className, " ") }, res, { children: [jsx(IonLabel, { children: props.label }), jsx(IonLabel, { children: props.floor })] })));
};

var Textarea = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? undefined : _b, rest = __rest(_a, ["placeholder"]);
    return jsx(IonTextarea, __assign({ placeholder: placeholder === null ? undefined : placeholder }, rest));
};

var css_248z$9 = ".styles-module_favButtonSty__UPNVb{background-color:#fff;border-radius:50px;display:flex;flex-direction:column;height:24px;justify-content:center;margin-left:37px;margin-top:-12px;padding:0;position:absolute;text-align:center;width:24px}.styles-module_favButtonSty__UPNVb::part(container){display:none}.styles-module_iconSty__1-Lmy{color:#111;font-size:17px;padding:0}.styles-module_iconStySelected__sGXN-{color:#fcaa4a}";
var styles$9 = {"favButtonSty":"styles-module_favButtonSty__UPNVb","iconSty":"styles-module_iconSty__1-Lmy","iconStySelected":"styles-module_iconStySelected__sGXN-"};
styleInject(css_248z$9);

var CheckFav = function (props) {
    return (jsx(IonCheckbox, __assign({ className: "".concat(styles$9.favButtonSty, " ").concat(styles$9.iconSty, " ").concat(props.checked ? 'icon icon-star-filled ' + styles$9.iconStySelected : 'icon icon-star-line', " ") }, props)));
};

var css_248z$8 = ".styles-module_notificationSty__uU2PS{border-radius:10px;box-shadow:0 2px 12px #11111114;height:72px;margin:0;padding:13px 16px;width:100%}.styles-module_notificationSty__uU2PS .styles-module_notificationContainer__q8iWn{align-content:center;align-items:center;display:flex;flex-wrap:nowrap;justify-content:flex-start}.styles-module_notificationSty__uU2PS .styles-module_notificationContainer__q8iWn .styles-module_divIcon__KqtgW{--border-style:none;border-radius:6px;height:46px;margin:0;min-width:46px;padding-top:10px;text-align:center}.styles-module_notificationSty__uU2PS .styles-module_notificationContainer__q8iWn .styles-module_divIcon__KqtgW .styles-module_iconSty__xR56S{font-size:24px}.styles-module_notificationSty__uU2PS .styles-module_notificationContainer__q8iWn .styles-module_containerTxtSty__9r1Zi{-webkit-line-clamp:2;-webkit-box-orient:vertical;color:var(--ion-color-primary);display:-webkit-box;font-size:13px;font-style:normal;font-weight:400;letter-spacing:0;margin-left:16px;overflow:hidden;text-overflow:ellipsis}.styles-module_notificationSty__uU2PS .styles-module_notificationContainer__q8iWn .styles-module_containerTxtSty__9r1Zi ion-router-link{color:var(--ion-color-secondary)}.styles-module_bgParking__1uCen{background-color:var(--ion-color-quaternary)}.styles-module_bgRoom__AAz-U{background-color:var(--ion-color-quinary)}.styles-module_bgWorkstation__pt8xf{background-color:var(--ion-color-primary)}.styles-module_bgNews__Vmtpw{background-color:var(--ion-color-tertiary);border:1px solid #e5e5e5;box-sizing:border-box}.styles-module_bgPending__0uIfS{background-color:#fcaa4a}.styles-module_bgNotice__IUeuW{background-color:var(--ion-color-secondary)}.styles-module_notice__A-JVH,.styles-module_parking__TxNcA,.styles-module_pending__sJZ-E,.styles-module_room__2OaBf,.styles-module_workstation__P7jRg{color:var(--ion-color-tertiary)}.styles-module_news__hs07A{color:var(--ion-color-primary)}";
var styles$8 = {"notificationSty":"styles-module_notificationSty__uU2PS","notificationContainer":"styles-module_notificationContainer__q8iWn","divIcon":"styles-module_divIcon__KqtgW","iconSty":"styles-module_iconSty__xR56S","containerTxtSty":"styles-module_containerTxtSty__9r1Zi","bgParking":"styles-module_bgParking__1uCen","bgRoom":"styles-module_bgRoom__AAz-U","bgWorkstation":"styles-module_bgWorkstation__pt8xf","bgNews":"styles-module_bgNews__Vmtpw","bgPending":"styles-module_bgPending__0uIfS","bgNotice":"styles-module_bgNotice__IUeuW","parking":"styles-module_parking__TxNcA","room":"styles-module_room__2OaBf","workstation":"styles-module_workstation__P7jRg","pending":"styles-module_pending__sJZ-E","notice":"styles-module_notice__A-JVH","news":"styles-module_news__hs07A"};
styleInject(css_248z$8);

var notificationClasses = {
    quaternary: "".concat(styles$8.bgParking),
    quinary: "".concat(styles$8.bgRoom),
    primary: "".concat(styles$8.bgWorkstation),
    tertiary: "".concat(styles$8.bgNews),
    warning: "".concat(styles$8.bgPending),
    secondary: "".concat(styles$8.bgNotice),
};
var classes = {
    quaternary: "".concat(styles$8.parking),
    quinary: "".concat(styles$8.room),
    primary: "".concat(styles$8.workstation),
    tertiary: "".concat(styles$8.news),
    warning: "".concat(styles$8.pending),
    secondary: "".concat(styles$8.notice),
};

var Notification = function (props) {
    var className = props.className, _a = props.model, model = _a === void 0 ? 'tertiary' : _a, icon = props.icon, text = props.text, res = __rest(props, ["className", "model", "icon", "text"]);
    return (jsx(IonCard, __assign({ className: "".concat(styles$8.notificationSty, " ").concat(className) }, res, { onClick: res.onClick }, { children: jsxs("div", __assign({ className: styles$8.notificationContainer }, { children: [jsx("div", __assign({ className: "".concat(styles$8.divIcon, " ").concat(notificationClasses[model]) }, { children: jsx(IonIcon, { className: "".concat(styles$8.iconSty, " ").concat(classes[model], " ").concat(icon) }) })), jsx("div", __assign({ className: styles$8.containerTxtSty }, { children: jsx(IonText, { children: text }) }))] })) })));
};

var css_248z$7 = ".styles-module_mainMenu__Frjiy{--width:375px;border-left:1px solid #e5e5e5}.styles-module_mainMenu__Frjiy .styles-module_menuToolbar__SIad-{--min-height:90px}.styles-module_mainMenu__Frjiy .styles-module_menuToolbar__SIad- .styles-module_largeTitle__d4cyv{color:var(--ion-color-primary);font-size:34px;font-style:normal;font-weight:700;letter-spacing:.374px;line-height:41px;padding:48px 22px 20px;text-align:left}";
var styles$7 = {"mainMenu":"styles-module_mainMenu__Frjiy","menuToolbar":"styles-module_menuToolbar__SIad-","largeTitle":"styles-module_largeTitle__d4cyv"};
styleInject(css_248z$7);

var Menu = function (props) {
    var className = props.className, res = __rest(props, ["className"]);
    return (jsxs(IonMenu, __assign({ className: "".concat(styles$7.mainMenu, " ").concat(className) }, res, { children: [jsx(IonHeader, __assign({ mode: "ios" }, { children: jsx(IonToolbar, __assign({ className: styles$7.menuToolbar }, { children: jsx(IonTitle, __assign({ className: styles$7.largeTitle }, { children: props.title })) })) })), props.children] })));
};

var Reorder = function (props) {
    return jsx(IonReorder, __assign({}, props));
};

var propTypes = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$1) {
			symbols = getOwnPropertySymbols$1(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$1.exports;
var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props;
        _this$props.sitekey;
        _this$props.onChange;
        _this$props.theme;
        _this$props.type;
        _this$props.tabindex;
        _this$props.onExpired;
        _this$props.onErrored;
        _this$props.size;
        _this$props.stoken;
        _this$props.grecaptcha;
        _this$props.badge;
        _this$props.hl;
        var childProps = _objectWithoutPropertiesLoose$1(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return React.createElement("div", _extends$1({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(React.Component);
ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  grecaptcha: PropTypes.object,
  theme: PropTypes.oneOf(["dark", "light"]),
  type: PropTypes.oneOf(["image", "audio"]),
  tabindex: PropTypes.number,
  onExpired: PropTypes.func,
  onErrored: PropTypes.func,
  size: PropTypes.oneOf(["compact", "normal", "invisible"]),
  stoken: PropTypes.string,
  hl: PropTypes.string,
  badge: PropTypes.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

var reactIs = reactIs$1.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props;
            _this$props.asyncScriptOnLoad;
            var forwardedRef = _this$props.forwardedRef,
            childProps = _objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return createElement(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = forwardRef(function (props, ref) {
      return createElement(AsyncScriptLoader, _extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: PropTypes.func
    };
    return hoistNonReactStatics_cjs(ForwardedComponent, WrappedComponent);
  };
}

var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

var RecaptchaWrapper = makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA);

var CaptchaV2 = function (props) {
    var language = 'es';
    var size = props.size || 'normal';
    var badge = props.badge || 'bottomright';
    var changeValue = useCallback(function (value) { return props.setToken(value); }, [props]);
    return (jsx(RecaptchaWrapper, { ref: props.reference, sitekey: props.siteKey, onChange: changeValue, hl: language, size: size, badge: badge }));
};

var css_248z$6 = ".styles-module_list__hJUHY{border:1px solid #00000021;border-top:none;box-shadow:1px 4px 4px 0 #00000026;max-height:200px;overflow-y:scroll;padding-top:0!important;position:absolute;width:100%;z-index:99}.styles-module_listContainer__Y2HC-{position:relative}.styles-module_listHeader__s8HAM{border:1px solid #00000021}.styles-module_listHeader__s8HAM::part(native){padding-left:16px}.styles-module_listHeader__s8HAM ion-label{margin:0}ion-checkbox{margin-right:16px}.styles-module_summary__VBiF5{text-wrap:wrap;color:#696969!important;text-align:right;text-overflow:ellipsis}.styles-module_listOptions__xOo--{z-index:10}.styles-module_listOptions__xOo-- ion-checkbox{height:20px;width:100%}.styles-module_button__FuYMo::part(native){padding:0 0 0 16px}.styles-module_endArrow__fKEPn{max-width:50px!important;text-align:right!important}";
var styles$6 = {"list":"styles-module_list__hJUHY","listContainer":"styles-module_listContainer__Y2HC-","listHeader":"styles-module_listHeader__s8HAM","summary":"styles-module_summary__VBiF5","listOptions":"styles-module_listOptions__xOo--","button":"styles-module_button__FuYMo","endArrow":"styles-module_endArrow__fKEPn"};
styleInject(css_248z$6);

var MultiSelect = function (_a) {
    var updateSelection = _a.updateSelection, options = _a.options, selected = _a.selected, label = _a.label, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, placeholder = _a.placeholder, _c = _a.showItemCount, showItemCount = _c === void 0 ? false : _c, _d = _a.itemCountText, itemCountText = _d === void 0 ? { singular: 'Item', plural: 'Items' } : _d;
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    return (jsxs("div", __assign({ className: "".concat(styles$6.listContainer, " ").concat(className ? className : '') }, { children: [jsxs(Item, __assign({ mode: "ios", lines: "none", type: "button", onClick: function () { return setOpen(!open); }, className: styles$6.listHeader }, { children: [jsx(IonLabel, __assign({ slot: "start", className: "multiselect-label" }, { children: label })), jsx(IonLabel, __assign({ className: styles$6.summary }, { children: selected.length === 0
                            ? placeholder
                            : showItemCount
                                ? "".concat(selected.length, " ").concat(selected.length === 1 ? itemCountText.singular : itemCountText.plural)
                                : options
                                    .filter(function (option) { return selected.includes(option.value); })
                                    .map(function (option) { return option.label; })
                                    .join(', ') })), jsx(IonLabel, __assign({ slot: "end", className: "".concat(styles$6.endArrow) }, { children: jsx(IonButton, __assign({ fill: "clear", className: "".concat(styles$6.button) }, { children: jsx(Icon, { className: "icon ".concat(open ? 'icon-chevron-up' : 'icon-chevron-down', " icon-24 ") }) })) }))] }), 'list_title'), open && (jsx(List, __assign({ className: styles$6.list }, { children: jsx("div", __assign({ className: styles$6.listOptions }, { children: options.map(function (option) {
                        var _a;
                        return (jsx(Item, __assign({ lines: "none" }, { children: jsx(IonCheckbox, __assign({ className: styles$6.checkBox, mode: "ios", checked: Boolean(selected && selected.includes(option.value)), onIonChange: function () { return updateSelection(option.value); }, disabled: (_a = option === null || option === void 0 ? void 0 : option.disabled) !== null && _a !== void 0 ? _a : disabled, labelPlacement: "end", justify: "start" }, { children: option.label })) }), option.value));
                    }) })) })))] })));
};

var css_248z$5 = ".styles-module_toolListSty__qVIfS{--border-width:0px;box-shadow:0 -.5px 0 #b2b2b24d;display:flex;flex-direction:row;height:83px;justify-content:space-around;padding-top:20px;width:100%}";
var styles$5 = {"toolListSty":"styles-module_toolListSty__qVIfS"};
styleInject(css_248z$5);

var SocialToolBar = function (props) {
    var className = props.className, res = __rest(props, ["className"]);
    return (jsx(IonToolbar, __assign({}, res, { className: "".concat(styles$5.toolbarSty, " ").concat(className, " ") }, { children: jsx(IonList, __assign({ className: "".concat(styles$5.toolListSty, " ").concat(className) }, { children: props.children })) })));
};

var css_248z$4 = ".styles-module_title__lXiHY{padding-left:10%;padding-right:10%}";
var styles$4 = {"title":"styles-module_title__lXiHY"};
styleInject(css_248z$4);

var TopBar = function (props) {
    return (jsxs(IonToolbar, { children: [jsx(IonButtons, __assign({ slot: "start" }, { children: props.primaryActions })), jsx(IonButtons, __assign({ slot: "secondary" }, { children: props.secondaryActions })), jsx(IonTitle, __assign({ className: styles$4.title, size: props.sizeTitle }, { children: props.title })), jsx(IonButtons, __assign({ slot: "end" }, { children: props.endActions }))] }));
};

var Segmented = function (props) {
    return jsx(IonSegment, __assign({}, props));
};

var css_248z$3 = ".styles-module_scrollContainer__JWbr2{background:#0000;height:100%;overflow:auto;text-align:center;white-space:nowrap}.styles-module_scrollContainer__JWbr2 .styles-module_gridscroll__prSzZ{display:inline-block}.styles-module_scrollContainer__JWbr2 .styles-module_gridscroll__prSzZ .styles-module_imageMarker__X-SOh{margin:0 auto;position:relative}.styles-module_scrollContainer__JWbr2 .styles-module_gridscroll__prSzZ .styles-module_imageMarker__X-SOh .styles-module_image__siw2j{margin:0 auto;width:100%}.styles-module_scrollContainer__JWbr2 .styles-module_gridscroll__prSzZ .styles-module_fabBtn__FSiUg::part(native){border-radius:8px;height:50px;margin-top:4px;width:50px}.styles-module_scrollContainer__JWbr2 .styles-module_gridscroll__prSzZ .styles-module_greyBtn__WNE5r::part(native){background-color:#e5e5e5}.styles-module_scrollContainer__JWbr2 .styles-module_gridscroll__prSzZ .styles-module_chip__yinyO{background:#f5f5f5}";
var styles$3 = {"scrollContainer":"styles-module_scrollContainer__JWbr2","gridscroll":"styles-module_gridscroll__prSzZ","imageMarker":"styles-module_imageMarker__X-SOh","image":"styles-module_image__siw2j","fabBtn":"styles-module_fabBtn__FSiUg","greyBtn":"styles-module_greyBtn__WNE5r","chip":"styles-module_chip__yinyO"};
styleInject(css_248z$3);

var getCenter = function (coords) {
    var xs = coords.map(function (item) { return item.y; });
    var ys = coords.map(function (item) { return item.x; });
    return {
        y: (Math.min.apply(Math, xs) + Math.max.apply(Math, xs)) / 2,
        x: (Math.min.apply(Math, ys) + Math.max.apply(Math, ys)) / 2,
    };
};
var groupBy = function (objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
        var key = obj['location'][property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
};

var css_248z$2 = ".styles-module_button__rVuU0{background-color:#4bd27f;border-radius:50%;color:#fff;font-size:20px;height:60px;position:absolute;text-align:center;width:60px}.styles-module_selected__eVXOp{background-color:#111}";
var styles$2 = {"button":"styles-module_button__rVuU0","selected":"styles-module_selected__eVXOp"};
styleInject(css_248z$2);

var DistrictButton = function (props) {
    var position = props.position, res = __rest(props, ["position"]);
    return (jsx("button", __assign({ style: position, className: "".concat(styles$2.button, " ").concat(res.selected ? styles$2.selected : ''), onClick: res.onClick }, { children: res.workstations })));
};

var css_248z$1 = ".styles-module_button__EYD8Y{background-color:#4bd27f;border-radius:4px;height:32px;position:absolute;text-align:center;width:32px}.styles-module_button__EYD8Y .styles-module_icon__6rssq{color:#fff;font-size:24px;height:100%;width:100%}.styles-module_selected__2nrS5{background-color:#111;color:#fff}";
var styles$1 = {"button":"styles-module_button__EYD8Y","icon":"styles-module_icon__6rssq","selected":"styles-module_selected__2nrS5"};
styleInject(css_248z$1);

var WorkstationButton = function (props) {
    var position = props.position, res = __rest(props, ["position"]);
    return (jsx("button", __assign({ style: position, className: "".concat(styles$1.button, " ").concat(res.selected ? styles$1.selected : ''), onClick: res.onClick }, { children: res.selected ? (jsx(IonIcon, { className: styles$1.icon, icon: checkmark })) : (jsx(IonIcon, { className: styles$1.icon, icon: add })) })));
};

var MapStationMarker$1 = function (props) {
    var source = props.source, dataWorkstations = props.dataWorkstations, maximum = props.maximum, district = props.district, onChange = props.onChange, onUserDistrictFocus = props.onUserDistrictFocus, unselectWs = props.unselectWs, myFloor = props.myFloor, _a = props.paddingTop, paddingTop = _a === void 0 ? 0 : _a;
    var _b = useState(false), loaded = _b[0], setloaded = _b[1];
    var _c = useState(), src = _c[0], setSrcImage = _c[1];
    var _d = useState([]), markers = _d[0], setMarkers = _d[1];
    var _e = useState([]), districtsOrg = _e[0], setDistrictsOrgs = _e[1];
    var _f = useState(null), selectedDistrict = _f[0], setSelectedDistrict = _f[1];
    var _g = useState(0), countSelected = _g[0], addSelected = _g[1];
    var _h = useState([]), districts = _h[0], setDistricts = _h[1];
    var _j = useState([]), workstations = _j[0], setWorkstations = _j[1];
    var _k = useState(false), zoonWorkstation = _k[0], setZoomWorkstation = _k[1];
    var _l = useState(false), isUserDist = _l[0], setIsUserDist = _l[1];
    var imgRef = useRef(null);
    var scrollref = useRef(null);
    var containerImgRef = useRef(null);
    var withDistrictImage = 0.7; //Percentage
    var heightDistrictImage = 0.65; //Percentage
    var withWorkstationImage = 1.41; //Percentage
    var heightWorkstationImage = 1.3; //Percentage
    var markSize = 16;
    useEffect(function () {
        if (zoonWorkstation) {
            handleImageLoaded();
            setZoomWorkstation(false);
        }
        if (dataWorkstations) {
            var selected = dataWorkstations.filter(function (item) { return item.selected; });
            addSelected(selected.length);
        }
        setSrcImage(source);
        loaded && loadData();
    }, [source, dataWorkstations]);
    useEffect(function () {
        //Coordinates Translation to adapt the size of the image
        zoonWorkstation === false && scrollToCenterUserDistZoomOut(districts);
        if (zoonWorkstation === false && districts.length) {
            setMarkers(districts);
        }
        else if (zoonWorkstation && workstations.length) {
            setMarkers(workstations);
        }
    }, [districts, workstations]);
    useEffect(function () {
        if (unselectWs) {
            unselectWs.selected = true;
            handleSelectWorkstation(unselectWs);
        }
    }, [unselectWs]);
    /**
     * Return top and left object
     * @param marker
     * @returns
     */
    var getPixelCoordMark = function (marker) {
        return {
            top: "".concat(marker.y, "px"),
            left: "".concat(marker.x, "px"),
        };
    };
    /**
     * Load and adjust wokrstations data
     */
    var loadData = function () {
        if (dataWorkstations) {
            var dis = groupBy(dataWorkstations, 'district');
            var dataDistricts = Object.values(dis).map(function (group) { return (__assign(__assign({}, getCenter(group)), {
                spaceId: group[0].location.district,
                numWorkrooms: group.length,
                selected: group.find(function (workstation) { return workstation.selected; }) && true,
            })); });
            setDistrictsOrgs(dataDistricts);
            imgRef.current &&
                setDistricts(transformCoordinates(dataDistricts, imgRef.current.naturalWidth * withDistrictImage, imgRef.current.naturalHeight * heightDistrictImage, imgRef.current.naturalWidth, imgRef.current.naturalHeight));
            imgRef.current &&
                setWorkstations(transformCoordinates(dataWorkstations, imgRef.current.naturalWidth * withWorkstationImage, imgRef.current.naturalHeight * heightWorkstationImage, imgRef.current.naturalWidth, imgRef.current.naturalHeight));
        }
    };
    /**
     * Resize the image and its container according to the parameters, calculate the district data and
     * set the coordinates of the adjusted districts and workstations based on the image.
     * @param width pixels
     * @param height pixels
     */
    var resizeImage = function (percentageWidth, percentageHeight) {
        if (containerImgRef.current != null && imgRef.current != null) {
            var height = imgRef.current.naturalHeight * percentageHeight;
            var width = imgRef.current.naturalWidth * percentageWidth;
            containerImgRef.current.style.width = "".concat(width, "px");
            containerImgRef.current.style.height = "".concat(height, "px");
            imgRef.current.style.width = "".concat(width, "px");
            imgRef.current.style.height = "".concat(height, "px");
            if (!districts.length || !workstations.length) {
                loadData();
                setloaded(true);
            }
        }
    };
    /**
     * Scroll to image center
     * @param districts
     */
    var scrollToCenterImage = function () {
        var _a;
        if (imgRef.current != null) {
            var top_1 = (imgRef.current.naturalHeight * heightDistrictImage) / 2;
            var left = (imgRef.current.naturalWidth * withDistrictImage) / 2;
            (_a = scrollref.current) === null || _a === void 0 ? void 0 : _a.scrollTo(left - scrollref.current.clientWidth / 2, top_1 - scrollref.current.clientHeight / 2);
        }
    };
    var handleImageLoaded = function () {
        resizeImage(withDistrictImage, heightDistrictImage);
        scrollToCenterImage();
    };
    /**
     * Returns the new value of the coordinate based on the ratio between the parameterised sizes
     * @param coordinate
     * @param width
     * @param widthOrg
     * @returns
     */
    var computeCoordinate = function (coordinate, size, sizeOrg) {
        var ratio = size / sizeOrg;
        return coordinate * ratio;
    };
    /**
     * Returns an array of marks with the coordinates adjusted based on the size of the image.
     * @param coordinates
     * @param widhtImage
     * @param heightImage
     * @param orgWidth
     * @param orgHeight
     * @returns
     */
    var transformCoordinates = function (coordinates, widhtImage, heightImage, orgWidth, orgHeight) {
        return coordinates.map(function (marker) { return (__assign(__assign({
            y: computeCoordinate(marker.y, heightImage, orgHeight) - markSize + paddingTop,
            x: computeCoordinate(marker.x, widhtImage, orgWidth) - markSize,
            spaceId: marker.spaceId,
            selected: marker.selected,
        }, ((marker === null || marker === void 0 ? void 0 : marker.numWorkrooms) && { numWorkrooms: marker === null || marker === void 0 ? void 0 : marker.numWorkrooms })), ((marker === null || marker === void 0 ? void 0 : marker.location) && { location: { district: marker === null || marker === void 0 ? void 0 : marker.location.district } }))); });
    };
    /**
     * Transform district coordenates and scroll to central position of screen
     * @param districtName
     */
    var scrollToCenterDist = function (districtName) {
        var _a;
        var dis = districtsOrg.find(function (district) { return district.spaceId === districtName; });
        if (dis) {
            var updatedDistrict = imgRef.current &&
                transformCoordinates([dis], imgRef.current.naturalWidth * withWorkstationImage, imgRef.current.naturalHeight * heightWorkstationImage, imgRef.current.naturalWidth, imgRef.current.naturalHeight);
            updatedDistrict &&
                ((_a = scrollref.current) === null || _a === void 0 ? void 0 : _a.scrollTo(updatedDistrict[0].x - document.documentElement.clientWidth / 2, updatedDistrict[0].y - document.documentElement.clientHeight / 3));
        }
    };
    /**
     * Scroll to user district  coordantes (without zoom)
     * @param districts
     */
    var scrollToCenterUserDistZoomOut = function (districts) {
        var _a;
        var dist = districts.find(function (item) { return item.spaceId === district; });
        if (dist) {
            setIsUserDist(true);
            (_a = scrollref.current) === null || _a === void 0 ? void 0 : _a.scrollTo(dist.x - document.documentElement.clientWidth / 2, dist.y - document.documentElement.clientHeight / 2.5);
        }
        else {
            setIsUserDist(false);
            //Scroll to image center
            scrollToCenterImage();
        }
    };
    /**
     * Manage the selection of the district
     * @param marker
     */
    var handleSelectDistrict = function (marker) {
        resizeImage(withWorkstationImage, heightWorkstationImage);
        setZoomWorkstation(true);
        setMarkers(workstations);
        setSelectedDistrict(marker);
        scrollToCenterDist(marker.spaceId);
    };
    /**
     * Manage zoom out
     */
    var handleZoomOut = function () {
        var _a;
        resizeImage(withDistrictImage, heightDistrictImage);
        setZoomWorkstation(false);
        setMarkers(districts);
        selectedDistrict &&
            ((_a = scrollref.current) === null || _a === void 0 ? void 0 : _a.scrollTo(selectedDistrict.x - document.documentElement.clientWidth / 2, selectedDistrict.y - document.documentElement.clientHeight / 2.5));
    };
    /**
     * Manage the selection of a workstation
     * @param workstationSelected
     */
    var handleSelectWorkstation = function (workstationSelected) {
        if (maximum !== countSelected || !!workstationSelected.selected) {
            addSelected(workstationSelected.selected ? countSelected - 1 : countSelected + 1);
            //update workstations
            var updatedWorkstations_1 = workstations.map(function (workstation) {
                return workstation.spaceId === workstationSelected.spaceId
                    ? __assign(__assign({}, workstation), { selected: !workstationSelected.selected }) : workstation;
            });
            setWorkstations(updatedWorkstations_1);
            //update districts
            var updatedDistricts = districts.map(function (district) {
                return district.spaceId === workstationSelected.location.district
                    ? __assign(__assign({}, district), { selected: updatedWorkstations_1.find(function (workstation) { return workstation.location.district === district.spaceId && workstation.selected; }) === undefined
                            ? false
                            : true }) : district;
            });
            setDistricts(updatedDistricts);
            return (onChange && onChange(__assign(__assign({}, workstationSelected), { selected: !workstationSelected.selected }))
            // onChange(updatedWorkstations.filter((item: Workstation) => item.spaceId === workstationSelected.spaceId))
            );
        }
        else {
            return onChange && onChange(null);
        }
    };
    /**
     * Manage the positioning on the user's district
     */
    var handleDistrictFocus = function () {
        if (isUserDist) {
            if (!zoonWorkstation) {
                var dist = markers.find(function (item) { return item.spaceId === district; });
                dist && handleSelectDistrict(dist);
            }
            else {
                scrollToCenterDist(district);
            }
        }
        else {
            return onUserDistrictFocus && onUserDistrictFocus(false);
        }
    };
    /**
     * Calculate the central position of image and scroll to it
     */
    var handleZoomIn = function () {
        var _a, _b, _c, _d, _e;
        var top = scrollref.current ? ((_a = scrollref.current) === null || _a === void 0 ? void 0 : _a.scrollTop) + scrollref.current.clientHeight / 2 : 0;
        var left = scrollref.current ? ((_b = scrollref.current) === null || _b === void 0 ? void 0 : _b.scrollLeft) + scrollref.current.clientWidth / 2 : 0;
        resizeImage(withWorkstationImage, heightWorkstationImage);
        setZoomWorkstation(true);
        console.log('***********', workstations);
        setMarkers(workstations);
        setSelectedDistrict({ y: top, x: left, spaceId: '' });
        var transformedTop = ((_c = imgRef.current) === null || _c === void 0 ? void 0 : _c.naturalHeight) ? top / heightDistrictImage : 0;
        var transformedLeft = ((_d = imgRef.current) === null || _d === void 0 ? void 0 : _d.naturalWidth) ? left / withDistrictImage : 0;
        (_e = scrollref.current) === null || _e === void 0 ? void 0 : _e.scrollTo(transformedLeft, transformedTop);
    };
    var handleScroll = function () {
        return props.onScroll && props.onScroll();
    };
    return (jsx("div", __assign({ ref: scrollref, className: styles$3.scrollContainer, onScroll: handleScroll }, { children: jsxs("div", __assign({ className: styles$3.gridscroll }, { children: [jsxs("div", __assign({ ref: containerImgRef, className: styles$3.imageMarker, style: { paddingTop: "".concat(paddingTop, "px") } }, { children: [src && (jsx("img", { src: src, ref: imgRef, alt: 'Floor map', onLoad: handleImageLoaded, className: styles$3.image })), dataWorkstations.length && markers
                            ? markers.map(function (marker) {
                                return zoonWorkstation ? (jsx(WorkstationButton, { position: getPixelCoordMark(marker), onClick: function () { return handleSelectWorkstation(marker); }, selected: marker.selected }, marker.spaceId)) : (jsx(DistrictButton, { position: getPixelCoordMark(marker), onClick: function () { return handleSelectDistrict(marker); }, workstations: marker.numWorkrooms, selected: marker.selected }, marker.spaceId));
                            })
                            : null] })), jsxs(IonFab, __assign({ vertical: "bottom", horizontal: "end" }, { children: [jsx(IonFabButton, __assign({ className: "".concat(styles$3.fabBtn, " ").concat(!isUserDist && myFloor ? styles$3.greyBtn : ''), color: "".concat(myFloor && !isUserDist ? 'dark' : 'primary'), onClick: handleDistrictFocus }, { children: jsx(IonIcon, { className: "icon icon-neighbourhood ".concat(!isUserDist && myFloor ? styles$3.greyIcon : '') }) })), zoonWorkstation ? (jsx(IonFabButton, __assign({ className: styles$3.fabBtn, color: "primary", onClick: handleZoomOut }, { children: jsx(IonIcon, { className: "icon icon-minus" }) }))) : (jsx(IonFabButton, __assign({ className: styles$3.fabBtn, color: "primary", onClick: handleZoomIn }, { children: jsx(IonIcon, { className: "icon icon-plus" }) })))] }))] })) })));
};

var css_248z = ".styles-module_scrollContainer__Lh4YW{background:#0000;height:100%;overflow:auto;text-align:center;white-space:nowrap}.styles-module_scrollContainer__Lh4YW .styles-module_gridscroll__ZOt72{display:inline-block}.styles-module_scrollContainer__Lh4YW .styles-module_gridscroll__ZOt72 .styles-module_imageMarker__M2F6H{margin:0 auto;position:relative}.styles-module_scrollContainer__Lh4YW .styles-module_gridscroll__ZOt72 .styles-module_imageMarker__M2F6H .styles-module_image__5pqqm{margin:0 auto;width:100%}.styles-module_scrollContainer__Lh4YW .styles-module_gridscroll__ZOt72 .styles-module_fabBtn__Pd-dq::part(native){border-radius:8px;height:50px;margin-top:4px;width:50px}.styles-module_scrollContainer__Lh4YW .styles-module_gridscroll__ZOt72 .styles-module_chip__06azw{background:#f5f5f5}";
var styles = {"scrollContainer":"styles-module_scrollContainer__Lh4YW","gridscroll":"styles-module_gridscroll__ZOt72","imageMarker":"styles-module_imageMarker__M2F6H","image":"styles-module_image__5pqqm","fabBtn":"styles-module_fabBtn__Pd-dq","chip":"styles-module_chip__06azw"};
styleInject(css_248z);

var MapStationMarker = function (props) {
    var source = props.source, dataWorkstations = props.dataWorkstations, maximum = props.maximum, onChange = props.onChange;
    var _a = useState(false), loaded = _a[0], setloaded = _a[1];
    var _b = useState(), src = _b[0], setSrcImage = _b[1];
    var _c = useState([]), markers = _c[0], setMarkers = _c[1];
    var _d = useState(0), countSelected = _d[0], addSelected = _d[1];
    var _e = useState([]), workstations = _e[0], setWorkstations = _e[1];
    var imgRef = useRef(null);
    var scrollref = useRef(null);
    var containerImgRef = useRef(null);
    var withWorkstationImage = 3000;
    var heightWorkstationImage = 3000;
    useEffect(function () {
        var selected = dataWorkstations.filter(function (item) { return item.selected; });
        addSelected(selected.length);
        setSrcImage(source);
        loaded && loadData();
    }, [source, dataWorkstations]);
    useEffect(function () {
        if (workstations.length) {
            setMarkers(workstations);
        }
    }, [workstations]);
    /**
     * Return top and left object
     * @param marker
     * @returns
     */
    var getPixelCoordMark = function (marker) {
        return {
            top: "".concat(marker.y, "px"),
            left: "".concat(marker.x, "px"),
        };
    };
    /**
     * Load and adjust wokrstations data
     */
    var loadData = function () {
        imgRef.current &&
            setWorkstations(transformCoordinates(dataWorkstations, withWorkstationImage, heightWorkstationImage, imgRef.current.naturalWidth, imgRef.current.naturalHeight));
    };
    /**
     * Resize the image and its container according to the parameters, calculate the district data and
     * set the coordinates of the adjusted districts and workstations based on the image.
     * @param width pixels
     * @param height pixels
     */
    var resizeImage = function (width, height) {
        if (containerImgRef.current != null && imgRef.current != null) {
            containerImgRef.current.style.width = "".concat(width, "px");
            containerImgRef.current.style.height = "".concat(height, "px");
            imgRef.current.style.width = "".concat(width, "px");
            imgRef.current.style.height = "".concat(height, "px");
            if (!workstations.length) {
                loadData();
                setloaded(true);
            }
        }
    };
    var handleImageLoaded = function () {
        var _a;
        resizeImage(withWorkstationImage, heightWorkstationImage);
        //Scroll to center of image
        var y = heightWorkstationImage / 2;
        var x = withWorkstationImage / 2;
        (_a = scrollref.current) === null || _a === void 0 ? void 0 : _a.scrollTo(x - scrollref.current.clientWidth / 2, y - scrollref.current.clientHeight / 2);
    };
    /**
     * Returns the new value of the coordinate based on the ratio between the parameterised sizes
     * @param coordinate
     * @param width
     * @param widthOrg
     * @returns
     */
    var computeCoordinate = function (coordinate, size, sizeOrg) {
        var ratio = size / sizeOrg;
        return coordinate * ratio;
    };
    /**
     * Returns an array of marks with the coordinates adjusted based on the size of the image.
     * @param coordinates
     * @param widhtImage
     * @param heightImage
     * @param orgWidth
     * @param orgHeight
     * @returns
     */
    var transformCoordinates = function (coordinates, widhtImage, heightImage, orgWidth, orgHeight) {
        return coordinates.map(function (marker) { return (__assign({
            y: computeCoordinate(marker.y, heightImage, orgHeight),
            x: computeCoordinate(marker.x, widhtImage, orgWidth),
            id: marker.id,
            selected: marker.selected,
        })); });
    };
    /**
     * Manage the selection of a workstation
     * @param workstationSelected
     */
    var handleSelectWorkstation = function (workstationSelected) {
        if (maximum !== countSelected || !!workstationSelected.selected) {
            addSelected(workstationSelected.selected ? countSelected - 1 : countSelected + 1);
            //update workstations
            var updatedWorkstations = workstations.map(function (workstation) {
                return workstation.id === workstationSelected.id
                    ? __assign(__assign({}, workstation), { selected: !workstationSelected.selected }) : workstation;
            });
            setWorkstations(updatedWorkstations);
            return (onChange && onChange(__assign(__assign({}, workstationSelected), { selected: !workstationSelected.selected }))
            // onChange(updatedWorkstations.filter((item: Workstation) => item.id === workstationSelected.id))
            );
        }
        else {
            return onChange && onChange(null);
        }
    };
    return (jsx(IonContent, { children: jsx("div", __assign({ ref: scrollref, className: styles.scrollContainer }, { children: jsx("div", __assign({ className: styles.gridscroll }, { children: jsxs("div", __assign({ ref: containerImgRef, className: styles.imageMarker }, { children: [jsx("img", { src: src, ref: imgRef, alt: 'Imagen sede cantrabria', onLoad: handleImageLoaded, className: styles.image }), markers &&
                            markers.map(function (marker) { return (jsx(WorkstationButton, { position: getPixelCoordMark(marker), onClick: function () { return handleSelectWorkstation(marker); }, selected: marker.selected }, marker.id)); })] })) })) })) }));
};

var Cluster = function (props) {
    return jsx(IonSegment, __assign({ scrollable: true }, props));
};

var ReorderGroup = function (props) {
    return jsx(IonReorderGroup, __assign({}, props));
};

export { ActionSheet, Alert, Button, CaptchaV2, Card, CardContent, CardHeader, CardSubtitle, CardTitle, CheckFav, Chip, Cluster, ClusterButton, DayCalendar, FilterChip, Icon, Item, List, ListHeader, MapStationMarker$1 as MapStationMarker, MapStationMarker as MapWorkstationMarker, Menu, Modal, MultiSelect, MultipleDaysCalendar, Notification, PickerCalendar, ProgressBar, RangeCalendar, Reorder, ReorderGroup, SearchBar, SegmentButton, Segmented, Snackbar, SocialToolBar, SocialToolBarItem, TextField, Textarea, Toast, TopBar, WeekCalendar, WeekCalendarMultiselector };
